import { Download } from "@mui/icons-material";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { TabContext } from "@mui/lab";
import {
  Box,
  Checkbox,
  CircularProgress,
  Grid2,
  MenuItem,
  Slide,
  Switch,
  Tab,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { cloneDeep } from "lodash";
import moment from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useMeasure from "react-use-measure";
import * as Yup from "yup";
import {
  addJdNotes,
  deleteJdNote,
  fixedJob,
  getJdNotes,
  getJobDataDetail,
  updateJdNote,
} from "../../../api/Api";
import BasicInformationIco from "../../../assets/icons/BasicInformationIco";
import ClipBoardCheck from "../../../assets/icons/ClipBoardCheckIco";
import ClosedJobIco from "../../../assets/icons/ClosedJobIco.js";
import DeleteIco from "../../../assets/icons/DeleteIco.js";
import DotsVerticalIco from "../../../assets/icons/DotsVerticalIco";
import ExclamatoryIco from "../../../assets/icons/ExclamatoryIco.js";
import EyeIco from "../../../assets/icons/EyeIco.js";
import InterviewSettingIco from "../../../assets/icons/InterviewSettingIco";
import JobPencilIco from "../../../assets/icons/JobPencilIco";
import JobPenIco from "../../../assets/icons/JobPenIco";
import JobStarIco from "../../../assets/icons/JobStarIco";
import NoteIco from "../../../assets/icons/NoteIco";
import RelevancyIndexIco from "../../../assets/icons/RelevancyIndexIco.js";
import RescoreIco from "../../../assets/icons/RescoreIco";
import ReviewInferredIco from "../../../assets/icons/ReviewInferredIco.js";
import ReviewPendingIco from "../../../assets/icons/ReviewPendingIco";
import ShareIco from "../../../assets/icons/ShareIco";
import SkillIco from "../../../assets/icons/SkillIco";
import VerifiedIco from "../../../assets/icons/VerifiedIco";
import CommonButton from "../../../component/Button";
import CommonLinearProgress from "../../../component/Linearprogress";
import SnackBar from "../../../component/SnackBar";
import ToogleButton from "../../../component/ToogleButton";
import {
  checkBackGroundProcess,
  JobAttachementCreateCall,
  JobAttachementDelete,
  JobAttachementDownload,
  JobAttachementTableGetCall,
  JobJobEdit,
  JobJobFormikData,
  JobJobRescore,
  JobJobReScore,
  JobJobShare,
  JobJobSubmit,
  JobSkillDetails,
  ResumePortalShare,
} from "../../../redux/action/Job";
import { TeamGetCall } from "../../../redux/action/UserManagement";
import { DELETE, GET, POST, PUT } from "../../../redux/axios/Axios";
import {
  addColorToData,
  buildFinalData,
  GetFileIcon,
  getIcons,
  getToolTipIcon,
  HandleSkeletion,
  rebuildSourceFromFinalData,
} from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import CommonAccordion from "../../common-components/CommonAccordion.js";
import CreateNote from "../../common-components/CreateNote";
import SkillDeleteDialog from "../../common-components/DeleteDialog.js";
import {
  CreatehandleDataTime,
  handleCopyClick,
  handleCopyMouseLeave,
} from "../../common-components/JobFunction.js";
import NewDeleteNote from "../../common-components/NewDeleteNote";
import {
  CommonGrid2,
  CustomTooltip,
  StyledFlexRowView,
  TabPanelView,
} from "../../common-components/StyledComponents";
import Score from "../../ignite/sow-enrichment/components/Score";
import ShareQuickMatch from "../../matches/quick-match/components/ShareQuickMatch";
import {
  FileContainer,
  StyledLinearContainer,
} from "../../matches/quick-match/components/StyledComponent";
import CommonCard from "../common-card.js";
import EditIndex from "../common-card.js/Edit-Index.js";
import AddSeededDialog from "../create-job/components/AddSeededDialog";
import InterviewSettings from "../create-job/components/InterviewSettings";
import SeededPreScreen from "../create-job/components/SeededPreScreen";
import AttachmentDialog from "../jobs-candidate/components/AttachementDialog.js";
import Attachment from "../jobs-candidate/components/Attachment.js";
import DialogCandidateHub from "../jobs-candidate/components/DialogCandidateHub";
import {
  CommonTippy,
  CustomizeMenu,
  CustomizeSpan,
  CustomTooltipField,
  TabCardSection,
} from "../style";
import { JobMetaInfo } from "./components/JobDetails.js";
import JobReDiscovery from "./components/JobReDiscovery.js";
import AddNewSkillDialog from "./Dialog";
import GenerateSearchStringContent from "./Dialog/GenerateSearchStringContent.js";
import ResumeUploadPortalLink from "./Dialog/ResumeUploadPortalLink.js";
import ReviewInfo from "./Dialog/ReviewInfo.js";
import Notes from "./notes";
import RelevancyTable from "./RelevancyTable";
import Skill from "./Skill";

const JobInformation = ({
  // jobData.data,
  jobId,
  handleDownloadJdOpen,
  fetchData,
  handleClick,
  saveEditData,
  resumeTab,
  onTitleUpdate,
}) => {
  const [ref, bounds] = useMeasure();
  const [reviewInfo, setReviewInfo] = useState({
    open: false,
    disabled: false,
    draftLoading: false,
    rescoreLoading: false,
  });
  const ToogleData = [
    { name: "View", value: "View" },
    { name: "Edit", value: "Edit" },
  ];
  const [attachmentList, setAttachmentList] = useState({
    data: [],
    loading: false,
    download: false,
    view: false,
    attachementRowData: {},
  });
  const initialized = useRef(false);
  const [attachmentAnchorEl, setAttachmentAnchorEl] = useState(null);
  const attachementOpen = Boolean(attachmentAnchorEl);
  const [attachmentDialog, setAttachmentDialog] = useState({
    loading: false,
    disabled: false,
    open: false,
  });
  const [deleteButton, setDeleteButton] = useState({
    loading: false,
    open: false,
    content: "",
    id: "",
  });
  const [alignment, setAlignment] = React.useState("View");
  const [skillDialog, setSkillDialog] = useState({
    open: false,
    condition: false,
    stayLoading: false,
    leaveLoading: false,
    warning: false,
    disabled: false,
  });
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [dialogData, setDialogData] = useState({
    skill: "",
    experience_in_yrs: "",
    criticality_score: "",
    title: "Create",
    classificationData: [],
    classification: false,
    classificationDataValue: "",
    key: "",
    field: {},
  });
  const [noteList, setNoteList] = useState({
    open: false,
    laoding: false,
    noteId: "",
    type: "",
    note: "",
    created_at: "",
    job_history_reason: "",
    accecpting_less_more_candidates: "",
    locals_only: "",
    hybrid_days: "",
    project_scope: "",
    other_details: "",
    deadline_start: "",
    deadline_end: "",
  });
  const cardDataDetails = [
    {
      name: "Basic Information",
      status: "Verified",
      icon: <BasicInformationIco />,
      disabled: true,
      loading: false,
    },
    {
      name: "Skills Required",
      status: "Verified",
      icon: <SkillIco />,
      disabled: true,
      loading: false,
    },
    {
      name: "Interview Settings",
      status: "Verified",
      icon: <InterviewSettingIco />,
      disabled: true,
      loading: false,
    },
    {
      name: "Notes",
      status: "Verified",
      icon: <NoteIco />,
      disabled: true,
      loading: false,
    },
    {
      name: "Attachment",
      status: "Verified",
      icon: <NoteIco />,
      disabled: true,
      loading: false,
    },
  ];
  const [cardData, setCardData] = useState(cardDataDetails);

  const [cardValue, setCardValue] = useState({ value: 0, prev: 0 });
  const attachementHeaderData = [
    { name: "Name", width: "23%" },
    { name: "Type", width: "20%" },
    { name: "Status" },
    { name: "Created by" },
    { name: "Created Date" },
    {},
  ];

  const basicInformationRequiredFields = [
    "pay_rate",
    "start_date",
    "end_date",
    "location_targets",
    "location",
    "industry",
  ];
  const [deleteNoteDialogOpen, setDeleteNoteDialogOpen] = useState(false);
  const [notesTableList, setNotesTableList] = useState([]);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState({
    isLoading: true,
    searchLoading: true,
  });
  const JobJobEditData = useSelector((state) => state.jobs.jobJobEdit);
  const JobEditData = useSelector((state) => state.jobs.jobJobEditData);
  const JobRescore = useSelector((state) => state.jobs.jobJobRescore);
  const [jobData, setJobData] = useState({
    data: {},
    search_strategy: "",
  });

  const [buttonLoading, setButtonLoading] = useState(false);
  const [editButtonLoading, setEditButtonLoading] = useState(false);
  let dates = moment(new Date());
  let today = dates.format("L");
  const typeData = [
    { name: "Standard", id: "Blank" },
    { name: "Supplier Call", id: "Supplier Call" },
  ];
  const [shareDialogOpen, setShareDialogOpen] = useState({
    open: false,
    loading: false,
  });
  const [resumeUploadDialogOpen, setResumeUploadDialogOpen] = useState({
    open: false,
    loading: false,
    data: {},
    data_filled: false,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const [reScore, setReScore] = useState({
    disabled: false,
    noLoading: false,
    yesLoading: false,
    rescore: false,
    reRunOpen: false,
    noteOpen: false,
    file: false,
    condition_route: false,
  });

  const [seededDialog, setSeededDialog] = useState({
    deleteOpen: false,
    loading: false,
    values: "",
    index: "",
    content: "",
    addOpen: false,
  });
  const [fixLoader, setFixLoader] = useState(false);
  const iconVisible = true;
  const [backGroundprocess, setBackGroundprocess] = useState({
    open: false,
    openLoading: false,
    buttonLoading: false,
  });
  const query = new URLSearchParams(useLocation().search);
  const jobStatus = query.get("status");
  const [generateSearch, setGenerateSearch] = useState({
    open: false,
  });
  const [hoveredId, setHoveredId] = useState(null);

  const handleToogleChange = (event, newAlignment) => {
    const rescoreData = JobRescore && JobRescore?.[jobId];

    if (
      JSON.stringify(JobEditData.formikData) !==
      JSON.stringify(JobEditData.jobData)
    ) {
      handleClick();
    } else if (
      rescoreData &&
      rescoreData?.status !== "success" &&
      rescoreData?.status !== "fail"
    ) {
      setReScore((prev) => ({
        ...prev,
        rescore: true,
        file: true,
        reRunOpen: false,
        noteOpen: false,
        disabled: true,
        yesLoading: true,
        condition_route: false,
      }));
    } else if (newAlignment !== null) {
      if (newAlignment === "Edit" && jobData.data?.unscored) {
        setReScore((prev) => ({
          ...prev,
          rescore: true,
          reRunOpen: false,
          noteOpen: true,
          file: false,
          condition_route: true,
        }));
        setCheckBox(checkBox);
      } else setAlignment(newAlignment);
    }
  };

  const value = (value) => (value ? value : "-");
  const [userData, setUserData] = useState([]);

  const jobModifyData = {
    insights: [],
    job_title: "",
    job_owner: "",
    account_executive: "",
    company_name: "",
    industry: [],
    available_industry: [],
    pay_rate: {
      max: "",
      min: "",
      currency: "USD",
    },
    management_level: "",
    available_management_level: [],
    employment: "",
    available_employment_types: [],
    start_date: "",
    end_date: "",
    criticalityHardData: [
      { name: "Familiar", value: "Familiar" },
      { name: "Hands-on", value: "Hands-on" },
      { name: "Expert", value: "Expert" },
    ],
    criticalitySoftData: [
      { name: "Novice", value: "Novice" },
      { name: "Proficient", value: "Proficient" },
      { name: "Expert", value: "Expert" },
    ],
    priorityData: [
      {
        name: "Medium",
        value: "Additional Qualities",
        key: "medium_priority",
      },
      {
        name: "High",
        value: "Complementary Skills",
        key: "low_priority",
      },
      {
        name: "Highest",
        value: "Core Skills",
        key: "high_priority",
      },
    ],
    skillType: [
      { name: "Hard Skill", value: "extracted_hard_skill" },
      { name: "Soft Skill", value: "extracted_soft_skill" },
    ],
    occupational_classification: "",
    available_occupational_classification: [],
    employeeTarget: "",

    autoCompleteValue: "",
    id: "",
    reports_to: "",
    req_id: "",
    bu_department_team: "",
    company_profile: "",
    available_company_profiles: [],
    education: "",
    specific_degree: "",
    available_education: "",
    dei: false,
    govt_security_clearance: false,
    languages: [],
    certificates: [],
    certificates_value: "",
    employer_targets: [],
    employer_targets_value: "",
    location: "",
    work_location_type: "",
    available_work_location_type: [
      { id: "Onsite", name: "Onsite" },
      { id: "Remote", name: "Remote" },
      { id: "Hybrid", name: "Hybrid" },
      { id: "Travel", name: "Travel" },
    ],
    languages_value: "",
    location_targets: [],
    location_targets_value: "",
    shift: [],
    shift_value: "",
    skillData: {
      low_priority: [],
      high_priority: [],
      recommended: [],
      medium_priority: [],
    },
    score_certificates: false,
    score_education: false,
    score_employer_targets: false,
    score_hard_skills: false,
    score_languages: false,
    score_location_targets: false,
    score_soft_skills: false,
    score_visa: false,
    relevancy_index: [],
    interview_type: [],
    pre_screen_questions: [],
    available_visa_status: [],
    visa_status: [],
    enable_dynamic_pre_screen_questions: false,
    marked_as_verified: false,
    priority_type: "",
    is_inference_reviewed: false,
    key_colors: {},
    required_years_for_industry: "",
    pay_rate_label: "",
    industry_anomoly: {},
    pay_anomoly: {},
    management_level_anomoly: {},
    occupational_classification_anomoly: {},
    company_profile_anomoly: {},
    relevancy_index_anomoly: {},
    submission_deadline: null,
  };
  const [jobValue, setJobValue] = useState(jobModifyData);
  const [jobValidationCheck, setJobValidationCheck] = useState(jobModifyData);
  const [filterMandatoryData, setFilterMandatoryData] = React.useState({
    mandatoryDisabled:
      alignment === "View"
        ? !(
            jobData.data?.job_details?.job_title &&
            jobData.data?.job_details?.company_name
          )
        : !(jobValue?.job_title && jobValue?.company_name),
    mandatoryData: [],
  });

  const statusOptions = [
    {
      name: "Internal Recruiter",
      value: "internal_recruiter",
    },
    { name: "External Recruiter", value: "external_recruiter" },
    { name: "External vendor", value: "external_vendor" },
  ];

  const buildCheckBoxData = (resumeTab = []) => {
    return [
      {
        title: "Job Description",
        value: true,
      },
      ...(resumeTab.length
        ? [
            // GOLDEN RECORD
            ...resumeTab
              .filter((file) => file.record_type === "GOLDEN RECORD")
              .map((file) => ({
                title: "Golden Record",
                value: true,
                child: [
                  {
                    ...file,
                    title: file.name,
                    record_type: file.record_type,
                    value: true,
                    progress: 0,
                    buffer: 0,
                    type: file.file_name,
                    name: file.file_name,
                    visible: false,
                  },
                ],
              })),

            // HIRING MANAGER
            ...resumeTab
              .filter((file) => file.record_type === "HIRING MANAGER")
              .map((file) => ({
                title: "Hiring Manager",
                value: true,
                child: [
                  {
                    ...file,
                    title: file.name,
                    record_type: file.record_type,
                    value: true,
                    progress: 0,
                    buffer: 0,
                    type: file.file_name,
                    name: file.file_name,
                    visible: false,
                  },
                ],
              })),

            // CANDIDATES
            {
              title: "Candidates",
              value: true,
              child: resumeTab
                .filter(
                  (file) =>
                    file.record_type !== "HIRING MANAGER" &&
                    file.record_type !== "GOLDEN RECORD"
                )
                .map((file) => ({
                  ...file,
                  title: file.name,
                  record_type: file.record_type,
                  value: true,
                  progress: 0,
                  buffer: 0,
                  type: file.file_name,
                  name: file.file_name,
                  visible: false,
                })),
            },
          ]
        : []),
    ];
  };

  const [checkBox, setCheckBox] = useState(() => buildCheckBoxData(resumeTab));

  useEffect(() => {
    setCheckBox(buildCheckBoxData(resumeTab));
  }, [resumeTab]);

  useEffect(() => {
    if (alignment === "View") {
      fetchJobDataDetail(jobId);
      fetchAttachmentTableList(jobId);
      setJobValue(jobModifyData);
      fetchJobEdit(jobId);
    } else if (alignment === "Edit") {
      setJobValue(jobModifyData);
      fetchJobEdit(jobId);
    }
  }, [alignment, jobId]);

  useEffect(() => {
    fetchNotesTableList(jobId);
  }, [jobId]);

  useEffect(() => {
    if (saveEditData?.view) setAlignment("View");
  }, [saveEditData]);

  const handleDynmaicList = (data, image) => {
    return data?.flatMap((item) =>
      item?.content?.map((contentItem) => ({
        name: item?.name || "",
        content: contentItem,
        ...(image ? { image: image } : {}),
      }))
    );
  };

  useEffect(() => {
    if (Object.keys(JobJobEditData).length !== 0) {
      const clonedJobData = cloneDeep(JobJobEditData);
      const getValue = {
        ...jobValue,
        is_inference_reviewed: clonedJobData?.is_inference_reviewed || false,
        insights: clonedJobData?.insights || [],
        job_title: clonedJobData.job_title,
        job_owner: clonedJobData.job_owner || "",
        account_executive: clonedJobData.account_executive || "",
        company_name: clonedJobData.company_name,
        industry: buildFinalData(
          clonedJobData?.industry,
          clonedJobData?.available_industry
        ),
        available_industry: addColorToData(
          clonedJobData?.industry,
          clonedJobData?.available_industry
        ),
        management_level: clonedJobData.management_level,
        available_management_level: clonedJobData.available_management_level,
        employment: clonedJobData.employment,
        available_employment_types: clonedJobData.available_employment_types,
        start_date: dayjs(clonedJobData.start_date).isValid()
          ? dayjs(clonedJobData.start_date).format("DD MMM YYYY")
          : "",
        end_date: dayjs(clonedJobData.end_date).isValid()
          ? dayjs(clonedJobData.end_date).format("DD MMM YYYY")
          : "",
        occupational_classification: clonedJobData.occupational_classification,
        available_occupational_classification:
          clonedJobData.available_occupational_classification,
        id: clonedJobData.id,
        reports_to: clonedJobData.reports_to,
        req_id: clonedJobData.req_id,
        bu_department_team: clonedJobData.bu_department_team,
        company_profile: clonedJobData.company_profile,
        available_company_profiles: clonedJobData.available_company_profiles,
        education: clonedJobData.education,
        specific_degree: clonedJobData.specific_degree,
        available_education: clonedJobData.available_education,
        dei: clonedJobData.dei,
        govt_security_clearance: clonedJobData.govt_security_clearance,
        languages: handleDynmaicList(clonedJobData.languages),
        certificates: handleDynmaicList(clonedJobData.certificates),
        employer_targets: handleDynmaicList(clonedJobData.employer_targets),
        location: clonedJobData.location,
        work_location_type: clonedJobData.work_location_type,
        location_targets: handleDynmaicList(clonedJobData.location_targets),
        shift: handleDynmaicList(clonedJobData.shift),
        pay_rate: {
          ...clonedJobData.pay_rate,
          max: clonedJobData.pay_rate.max,
          min: clonedJobData.pay_rate.min,
          currency: clonedJobData.pay_rate.currency || "USD",
           period: !["Permanent - Full Time"].includes(clonedJobData?.employment)
            ? "hourly"
            : "yearly",
        },
        skillData: {
          low_priority: clonedJobData.low_priority,
          high_priority: clonedJobData.high_priority,
          recommended: clonedJobData.recommended,
          medium_priority: clonedJobData.medium_priority,
        },
        score_certificates: clonedJobData.score_certificates,
        score_education: clonedJobData.score_education,
        score_employer_targets: clonedJobData.score_employer_targets,
        score_hard_skills: clonedJobData.score_hard_skills,
        score_languages: clonedJobData.score_languages,
        score_location_targets: clonedJobData.score_location_targets,
        score_soft_skills: clonedJobData.score_soft_skills,
        score_visa: clonedJobData.score_visa,
        relevancy_index: clonedJobData.relevancy_index,
        interview_type: clonedJobData.interview_type,
        pre_screen_questions: clonedJobData.pre_screen_questions,
        available_visa_status: addColorToData(
          clonedJobData?.visa_status,
          clonedJobData.available_visa_status
        ),
        visa_status: buildFinalData(
          clonedJobData.visa_status,
          clonedJobData.available_visa_status
        ),
        enable_dynamic_pre_screen_questions:
          clonedJobData?.enable_dynamic_pre_screen_questions,
        priority_type: clonedJobData.priority_type,
        key_colors: clonedJobData?.key_colors || {},
        required_years_for_industry:
          clonedJobData?.required_years_for_industry?.years || "",
        pay_rate_label: ![
          "Permanent - Full Time",
          "Permanent - Part Time",
        ].includes(clonedJobData?.employment)
          ? "Hourly Target Bill Rate"
          : clonedJobData?.employment === "Permanent - Part Time"
          ? "Hourly Salary"
          : "Yearly Salary",
        industry_anomoly: clonedJobData.industry_anomoly,
        pay_anomoly: clonedJobData.pay_anomoly || {},
        management_level_anomoly: clonedJobData.management_level_anomoly || {},
        occupational_classification_anomoly:
          clonedJobData.occupational_classification_anomoly || {},
        company_profile_anomoly: clonedJobData.company_profile_anomoly || {},
        relevancy_index_anomoly: clonedJobData.relevancy_index_anomoly || {},
        submission_deadline: clonedJobData?.submission_deadline || null,
      };
      setJobValue(getValue);
      setJobValidationCheck(getValue);
    }
  }, [JobJobEditData]);

  const handleAddIcon = (viewData, editData, condition) => {
    const data =
      alignment === "Edit"
        ? editData?.anomaly_detected !== "no"
        : viewData?.anomaly_detected !== "no";

    return data ? (
      <Tooltip
        title={
          <CommonGrid2
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            textAlign={"center"}
          >
            {alignment === "Edit" ? editData?.anomaly : viewData?.anomaly}
          </CommonGrid2>
        }
        arrow
        placement="top"
      >
        <CustomizeSpan
          cursor="pointer"
          position="relative"
          top={condition.top}
          left={condition.left}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
              fill="#FEF0C7"
            />
            <g clip-path="url(#clip0_1_29287)">
              <path
                d="M11.9997 9.33325V11.9999M11.9997 14.6666H12.0063M18.6663 11.9999C18.6663 15.6818 15.6816 18.6666 11.9997 18.6666C8.31778 18.6666 5.33301 15.6818 5.33301 11.9999C5.33301 8.31802 8.31778 5.33325 11.9997 5.33325C15.6816 5.33325 18.6663 8.31802 18.6663 11.9999Z"
                stroke="#DC6803"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1_29287">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(4 4)"
                />
              </clipPath>
            </defs>
          </svg>
        </CustomizeSpan>
      </Tooltip>
    ) : (
      ""
    );
  };

  const handleInputChange = (e, title) => {
    const getValue = e.target.value;
    setJobValue((prev) => ({
      ...prev,
      [title]: getValue,
      key_colors: {
        ...prev?.key_colors,
        [title]:
          jobValidationCheck?.[title] === getValue
            ? jobValidationCheck?.["key_colors"]?.[title]
            : "user_added",
      },
    }));
  };

  const handleListChange = (value, title) => {
    setJobValue((prev) => ({
      ...prev,
      [title]: value,
      key_colors: {
        ...prev?.key_colors,
        [title]:
          jobValidationCheck?.[title] === value
            ? jobValidationCheck?.["key_colors"]?.[title]
            : "user_added",
      },
    }));
  };

  const handleCurrencyChange = (event, name, currency) => {
    const getValue = event.target.value;
    const updatedPayRate = {
      ...jobValue[name],
      [currency]: getValue,
    };

    setJobValue((prev) => ({
      ...prev,
      pay_rate: {
        ...updatedPayRate,
      },
      key_colors: {
        ...prev?.key_colors,
        [name]:
          parseInt(jobValidationCheck?.[name]?.[currency]) ===
          parseInt(getValue)
            ? jobValidationCheck?.["key_colors"]?.[name]
            : "user_added",
      },
    }));
  };

  const handleCurrencyDropdownChange = (event, name, currencyValue) => {
    const exchangeRate = 83;
    function convertUsdToInr(usdValue) {
      return usdValue * exchangeRate;
    }

    function convertInrToUsd(inrValue) {
      return inrValue / exchangeRate;
    }

    const updatedPayRate = {
      ...jobValue[name],
      [currencyValue]: event.target.value,
      min:
        event.target.value === "INR"
          ? convertUsdToInr(jobValue[name]["min"])
          : convertInrToUsd(jobValue[name]["min"]),
      max:
        event.target.value === "INR"
          ? convertUsdToInr(jobValue[name]["max"])
          : convertInrToUsd(jobValue[name]["max"]),
    };
    setJobValue((prev) => ({
      ...prev,
      pay_rate: {
        ...updatedPayRate,
      },
    }));
  };

  const handleChangeSwitch = (name, value) => {
    setJobValue((prev) => ({
      ...prev,
      [name]: value,
      key_colors: {
        ...prev?.key_colors,
        [name]:
          jobValidationCheck?.[name] === value
            ? jobValidationCheck?.["key_colors"]?.[name]
            : "user_added",
      },
    }));
  };

const HOURS_PER_YEAR = 2080;

const convertPayRate = (value, fromPeriod, toPeriod) => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return 0;
  }

  // No conversion needed
  if (fromPeriod === toPeriod) {
    return numericValue;
  }

  // Hourly -> Yearly
  if (fromPeriod === "hourly" && toPeriod === "yearly") {
    return numericValue * HOURS_PER_YEAR;
  }

  // Yearly -> Hourly
  if (fromPeriod === "yearly" && toPeriod === "hourly") {
    return numericValue / HOURS_PER_YEAR;
  }

  return numericValue;
};

  const handleDropdownChange = (event, name) => {
    const getValue = event.target.value;
    setJobValue((prev) => {
      const isPartTime = !getValue.includes("Permanent - Full Time");
      const isPermanentFullTime = getValue.includes("Permanent - Full Time");
      const isPermanentPartTime = getValue.includes("Permanent - Part Time");
      const isContractFullTime = getValue.includes("Contract - Full Time");
      const isContractPartTime = getValue.includes("Contract - Part Time");

       const prevEmployment = prev.employment || "";
    const prevIsPartTime = !prevEmployment.includes("Permanent - Full Time");
    const currentPeriod = prevIsPartTime ? "hourly" : "yearly";

      let updatedPayRate = { ...prev.pay_rate };
        if (name === "employment") {
      const newPeriod = isPartTime ? "hourly" : "yearly";

      if (currentPeriod !== newPeriod) {
        updatedPayRate = {
          ...updatedPayRate,
          max: convertPayRate(prev.pay_rate.max, currentPeriod, newPeriod),
          min: convertPayRate(prev.pay_rate.min, currentPeriod, newPeriod),
          period: newPeriod,
        };
      }


      // 🔹 Convert only if period actually changes
      if (isPartTime && currentPeriod !== "hourly") {
  updatedPayRate = {
    ...updatedPayRate,
    max: convertPayRate(
      prev.pay_rate.max,
      currentPeriod,
      "hourly"
    ),
    min: convertPayRate(
      prev.pay_rate.min,
      currentPeriod,
      "hourly"
    ),
    period: "hourly",
  };
}

if (!isPartTime && currentPeriod !== "yearly") {
  updatedPayRate = {
    ...updatedPayRate,
    max: convertPayRate(
      prev.pay_rate.max,
      currentPeriod,
      "yearly"
    ),
    min: convertPayRate(
      prev.pay_rate.min,
      currentPeriod,
      "yearly"
    ),
    period: "yearly",
  };
}
        }

      return {
        ...prev,
        [name]: getValue,
        ...(name === "employment"
          ? {
              pay_rate_label: isPermanentFullTime
                ? "Yearly Salary"
                : isPermanentPartTime
                ? "Hourly Salary"
                : isContractFullTime
                ? "Hourly Target Bill Rate"
                : isContractPartTime
                ? "Hourly Target Bill Rate"
                : "",
              // ? "Hourly Yearly Target Bill Rate"
              // : "Yearly Target Rate",

              pay_rate: {
                ...updatedPayRate,
                currency: prev.pay_rate.currency || "USD",
              },
            }
          : {}),
        key_colors: {
          ...prev?.key_colors,
          [name]:
            jobValidationCheck?.[name] === getValue
              ? jobValidationCheck?.["key_colors"]?.[name]
              : "user_added",
        },
      };
    });
  };

  const handleAutoCompleteInputChange = (value, name, setFieldValue) => {
    setFieldValue(name, value);
    setJobValue((prev) => ({
      ...prev,
      [name]: value,
      key_colors: {
        ...prev?.key_colors,
        [name]:
          jobValidationCheck?.[name] === value
            ? jobValidationCheck?.["key_colors"]?.[name]
            : "user_added",
      },
    }));
  };

  const handleAutoCompleteKeyDown = (
    e,
    index,
    name,
    inputValue,
    setFieldValue
  ) => {
    const checkData = jobValue[name];
    const dataValue = e.target.value;

    if (e.key === "Tab") {
      e.preventDefault();
      setFieldValue(inputValue, "");
      if (dataValue !== "") {
        const data = {
          name: "user_added",
          // ...(name !== "shift" ? { name: "user_added" } : { id: index }),
          content: dataValue,
        };

        const formattedValues = [...checkData, data];
        setJobValue((prev) => ({
          ...prev,
          [inputValue]: "",
          [name]: formattedValues,
        }));
      }
    }
  };

  const handleAutoCompleteDelete = (option, name) => {
    // Match by value, not reference: Formik keeps the old object references when
    // jobValue is rebuilt with deep-equal data, so `item !== option` never matched.
    setJobValue((prev) => {
      const list = prev[name] || [];
      const removeIndex = list.findIndex(
        (item) =>
          item === option ||
          (item?.content === option?.content && item?.name === option?.name)
      );
      if (removeIndex === -1) return prev;
      return {
        ...prev,
        [name]: list.filter((_, i) => i !== removeIndex),
      };
    });
  };

  const handleAutoCompleteChange = (e, newValue, name) => {
    const getValue = e.target.value;
    if (e?.key === "Backspace" && getValue === "") {
      const updatedValue = [...(jobValue[name] || [])];
      updatedValue.pop();
      setJobValue((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    } else {
      const formattedValues = newValue.map((item, index) => {
        if (typeof item === "string") {
          return {
            name: "user_added",
            // ...(name !== "shift" ? { name: "user_added" } : { id: index }),
            content: item,
          };
        }
        return item;
      });
      setJobValue((prev) => ({
        ...prev,
        [name]: formattedValues,
      }));
    }
  };

  const handleAutoMultiChange = (e, newValue, name) => {
    setJobValue((prev) => ({
      ...prev,
      [name]: newValue.map((item) => ({
        ...item,
        color: item?.color || "user_added",
      })),
    }));
  };

  const handleDatePicker = (name, date) => {
    const formattedDate = date ? dayjs(date).format("DD MMM YYYY") : "";
    setJobValue((prev) => ({
      ...prev,
      [name]: formattedDate,
      key_colors: {
        ...prev?.key_colors,
        [name]:
          jobValidationCheck?.[name] === formattedDate
            ? jobValidationCheck?.["key_colors"]?.[name]
            : "user_added",
      },
    }));
  };

  const mandatoryData = [
    {
      title: "Job Title",
      component: "input",
      titleName: "job_title",
      required: true,
      onChange: handleInputChange,
    },
    {
      title: "Company Name",
      component: "input",
      titleName: "company_name",
      required: true,
      onChange: handleInputChange,
    },
  ];

  const fieldLevelData = [
    {
      title: "Industry",
      component: "multi-complete",
      titleName: "industry",
      options: "available_industry",
      placeholder: "Select Industry",
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoMultiChange,
      anomaly: JobJobEditData?.industry_anomoly?.anomaly,
      anomaly_detected: JobJobEditData?.industry_anomoly,
      anomalyFieldName: "industry_anomoly",
    },
    {
      title: `Minimal ${jobValue?.pay_rate_label}`,
      component: "input-select",
      titleName: "pay_rate",
      currency: "min",
      anomaly: JobJobEditData?.pay_anomoly?.anomaly,
      currencyValue: "currency",
      handleCurrencyChange: handleCurrencyChange,
      handleCurrencyDropdownChange: handleCurrencyDropdownChange,
      anomaly_detected: JobJobEditData?.pay_anomoly,
      anomalyFieldName: "pay_anomoly",
    },
    {
      title: `Maximal ${jobValue?.pay_rate_label}`,
      anomaly: JobJobEditData?.pay_anomoly?.anomaly,
      anomaly_detected: JobJobEditData?.pay_anomoly,
      component: "input-select",
      titleName: "pay_rate",
      currency: "max",
      currencyValue: "currency",
      handleCurrencyChange: handleCurrencyChange,
      handleCurrencyDropdownChange: handleCurrencyDropdownChange,
      anomalyFieldName: "pay_anomoly",
    },
    {
      title: "Seniority Level",
      component: "dropDown",
      titleName: "management_level",
      dropDownData: "available_management_level",
      handleDropdownChange: handleDropdownChange,
      // field_type: "Inferred",
      anomaly: JobJobEditData?.management_level_anomoly?.anomaly,
      anomaly_detected: JobJobEditData?.management_level_anomoly,
      anomalyFieldName: "management_level_anomoly",
    },
    {
      title: "Occupational Classification",
      component: "dropDown",
      titleName: "occupational_classification",
      dropDownData: "available_occupational_classification",
      handleDropdownChange: handleDropdownChange,
      // field_type: "Inferred",
      anomaly: JobJobEditData?.occupational_classification_anomoly?.anomaly,
      anomaly_detected: JobJobEditData?.occupational_classification_anomoly,
      anomalyFieldName: "occupational_classification_anomoly",
    },
    {
      title: "Company Profile",
      component: "dropDown",
      titleName: "company_profile",
      dropDownData: "available_company_profiles",
      handleDropdownChange: handleDropdownChange,
      // field_type: "Inferred",
      anomaly: JobJobEditData?.company_profile_anomoly?.anomaly,
      anomaly_detected: JobJobEditData?.company_profile_anomoly,
      anomalyFieldName: "company_profile_anomoly",
    },
  ];

  const inferredSkill = [
    {
      title: "Occupational Classification",
      component: "dropDown",
      titleName: "occupational_classification",
      dropDownData: "available_occupational_classification",
      handleDropdownChange: handleDropdownChange,
      icon: <ReviewInferredIco />,
      field_type: "Inferred",
    },
    {
      title: "Company Profile",
      component: "dropDown",
      titleName: "company_profile",
      dropDownData: "available_company_profiles",
      handleDropdownChange: handleDropdownChange,
      icon: <ReviewInferredIco />,
      field_type: "Inferred",
    },
    {
      title: "Industry",
      component: "multi-complete",
      titleName: "industry",
      options: "available_industry",
      placeholder: "Select Industry",
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoMultiChange,
      icon: <ReviewInferredIco />,
      field_type: "Inferred",
    },
    {
      title: "Seniority Level",
      component: "dropDown",
      titleName: "management_level",
      dropDownData: "available_management_level",
      handleDropdownChange: handleDropdownChange,
      icon: <ReviewInferredIco />,
      field_type: "Inferred",
    },
    {
      title: "Employment Type",
      component: "dropDown",
      titleName: "employment",
      dropDownData: "available_employment_types",
      handleDropdownChange: handleDropdownChange,
      icon: <ReviewInferredIco />,
      field_type: "Inferred",
    },
  ];

  const anomalyData = [
    {
      title: "Industry",
      component: "multi-complete",
      titleName: "industry",
      options: "available_industry",
      placeholder: "Select Industry",
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoMultiChange,
    },
    {
      title: "Seniority Level",
      component: "dropDown",
      titleName: "management_level",
      dropDownData: "available_management_level",
      handleDropdownChange: handleDropdownChange,
    },
    {
      title: "Employment Type",
      component: "dropDown",
      titleName: "employment",
      dropDownData: "available_employment_types",
      handleDropdownChange: handleDropdownChange,
    },
    {
      title: "BU/Dept/Team",
      component: "input",
      titleName: "bu_department_team",
      onChange: handleInputChange,
    },
    {
      title: "Location",
      component: "input",
      titleName: "location",
      onChange: handleInputChange,
    },
    {
      title: "Highest Level of Education",
      component: "dropDown",
      titleName: "education",
      dropDownData: "available_education",
      handleDropdownChange: handleDropdownChange,
    },
    {
      title: "Visa Status",
      component: "multi-complete",
      titleName: "visa_status",
      options: "available_visa_status",
      placeholder: "Select Visa Status",
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoMultiChange,
    },
    {
      title: "Specialization",
      component: "input",
      titleName: "specific_degree",
      onChange: handleInputChange,
      handleChangeSwitch: handleChangeSwitch,
    },
    {
      title: "Location Targets",
      component: "autoComplete",
      titleName: "location_targets",
      inputValue: "location_targets_value",
      placeholder: "Enter Location Targets",
      handleChangeSwitch: handleChangeSwitch,
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleAutoCompleteKeyDown: handleAutoCompleteKeyDown,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoCompleteChange,
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"}>
          <JobPencilIco />
          <JobStarIco />
          <JobPenIco />
        </CommonGrid2>
      ),
      iconVisible: iconVisible,
    },
    {
      title: "Job Title",
      component: "input",
      titleName: "job_title",
      onChange: handleInputChange,
    },

    {
      title: `Minimal  ${jobValue?.pay_rate_label}`,
      component: "input-select",
      titleName: "pay_rate",
      currency: "min",
      default_value: JobJobEditData?.pay_rate?.min,
      currencyValue: "currency",
      anomaly_content: handleAddIcon(
        jobData.data?.job_details?.pay_anomoly,
        jobValue?.pay_anomoly,
        { top: "0px", left: "0px" }
      ),
      handleCurrencyChange: handleCurrencyChange,
      handleCurrencyDropdownChange: handleCurrencyDropdownChange,
      iconVisible: true,
    },
    {
      title: `Maximal  ${jobValue?.pay_rate_label}`,
      default_value: JobJobEditData?.pay_rate?.max,
      component: "input-select",
      titleName: "pay_rate",
      currency: "max",
      currencyValue: "currency",
      anomaly_content: handleAddIcon(
        jobData.data?.job_details?.pay_anomoly,
        jobValue?.pay_anomoly,
        { top: "0px", left: "0px" }
      ),
      iconVisible: true,
      handleCurrencyChange: handleCurrencyChange,
      handleCurrencyDropdownChange: handleCurrencyDropdownChange,
    },
    {
      title: "Start Date",
      titleName: "start_date",
      component: "single-calender",
      placeholder: "Select date",
      handleDatePicker: handleDatePicker,
    },
    {
      title: "End Date",
      titleName: "end_date",
      component: "single-calender",
      placeholder: "Select date",
      handleDatePicker: handleDatePicker,
    },
  ];

  const primaryViewData = [
    {
      title: "Job Title",
      name: value(jobData.data?.job_details?.job_title),
      component: "input",
      titleName: "job_title",
      editValue: jobValue,
      onChange: handleInputChange,
    },
    {
      title: "Company Name",
      name: value(jobData.data?.job_details?.company_name),
      component: "input",
      titleName: "company_name",
      editValue: jobValue,
      onChange: handleInputChange,
    },
    {
      title: "Employment Type",
      name: value(jobData.data?.job_details?.employment),
      component: "dropDown",
      value: jobValue.employment,
      data: jobValue.available_employment_types,
      titleName: "employment",
      dropDownData: "available_employment_types",
      handleDropdownChange: handleDropdownChange,
    },

    {
      title:
        alignment === "View"
          ? ` ${jobValue?.pay_rate_label}`
          : `Minimal  ${jobValue?.pay_rate_label}`,
      name: value(jobData.data?.job_details?.pay_rate),
      component: "input-select",
      titleName: "pay_rate",
      currency: "min",
      default_value: JobJobEditData?.pay_rate?.min,
      currencyValue: "currency",
      anomaly_content: handleAddIcon(
        jobData.data?.job_details?.pay_anomoly,
        jobValue?.pay_anomoly,
        { top: "0px", left: "0px" }
      ),
      handleCurrencyChange: handleCurrencyChange,
      handleCurrencyDropdownChange: handleCurrencyDropdownChange,
      iconVisible: true,
    },
    ...(alignment === "Edit"
      ? [
          {
            title: `Maximal ${jobValue?.pay_rate_label}`,
            name: value(jobData.data?.job_details?.pay_rate),
            default_value: JobJobEditData?.pay_rate?.max,
            component: "input-select",
            titleName: "pay_rate",
            currency: "max",
            currencyValue: "currency",
            anomaly_content: handleAddIcon(
              jobData.data?.job_details?.pay_anomoly,
              jobValue?.pay_anomoly,
              { top: "0px", left: "0px" }
            ),
            iconVisible: true,
            handleCurrencyChange: handleCurrencyChange,
            handleCurrencyDropdownChange: handleCurrencyDropdownChange,
          },
        ]
      : []),
    {
      title: "Seniority Level",
      name: value(jobData.data?.job_details?.management_level),
      component: "dropDown",
      titleName: "management_level",
      dropDownData: "available_management_level",
      anomaly_content: handleAddIcon(
        jobData.data?.job_details?.management_level_anomoly,
        jobValue?.management_level_anomoly,
        { top: "0px", left: "0px" }
      ),
      iconVisible: true,
      handleDropdownChange: handleDropdownChange,
    },

    {
      component: "split-part",
      data: [
        {
          title: "Location",
          // image: jobData.data?.job_details?.location ? Image : null,
          name: value(jobData.data?.job_details?.location),
          component: "input",
          titleName: "location",
          editValue: jobValue,
          onChange: handleInputChange,
        },
        {
          title: "Work Location Type",
          name: value(jobData?.data?.job_details?.work_location_type),
          component: "dropDown",
          titleName: "work_location_type",
          dropDownData: "available_work_location_type",
          placeholder: "Select Work Location Type",
          handleDropdownChange: handleDropdownChange,
        },
      ],
    },

    {
      title: "Start Date",
      name: value(jobData.data?.job_details?.start_date),
      titleName: "start_date",
      component: "single-calender",
      placeholder: "Select date",
      handleDatePicker: handleDatePicker,
    },
    {
      title: "End Date",
      name: value(jobData.data?.job_details?.end_date),
      titleName: "end_date",
      component: "single-calender",
      placeholder: "Select date",
      handleDatePicker: handleDatePicker,
    },

    {
      title: "Industry",
      customSize: 6,
      // additional: handleDynmaicListFormat(jobData.data?.job_details?.industry),
      multi_additional: handleDynmaicList(jobData.data?.job_details?.industry),
      component: "multi-complete",
      titleName: "industry",
      options: "available_industry",
      anomaly_content: handleAddIcon(
        jobData.data?.job_details?.industry_anomoly,
        jobValue?.industry_anomoly,
        { top: "0px", left: "0px" }
      ),
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"} alignItems={"center"}>
          {getIcons(
            handleDynmaicList(rebuildSourceFromFinalData(jobValue?.industry))
          ).map((icon) => icon)}
        </CommonGrid2>
      ),
      placeholder: "Select Industry",
      iconVisible: true,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoMultiChange,
    },
    {
      title: "Required Years for Industry",
      placeholder: "Enter the years",
      placeholderFontSize: "15px",
      customSize: 6,
      name: value(
        jobData.data?.job_details?.required_years_for_industry?.years
      ),
      component: "number",
      titleName: "required_years_for_industry",
      editValue: jobValue,
      onChange: handleInputChange,
    },
  ];

  const SecondaryViewData = [
    {
      title: "Occupational Classification",
      name: value(jobData.data?.job_details?.occupational_classification),
      component: "dropDown",
      titleName: "occupational_classification",
      dropDownData: "available_occupational_classification",
      anomaly_content: handleAddIcon(
        jobData.data?.job_details?.occupational_classification_anomoly,
        jobValue?.occupational_classification_anomoly,
        { top: "0px", left: "0px" }
      ),
      iconVisible: true,
      handleDropdownChange: handleDropdownChange,
    },
    {
      title: "Req ID",
      name: value(jobData.data?.job_details?.req_id),
      component: "input",
      titleName: "req_id",
      onChange: handleInputChange,
    },
    {
      title: "Shift",
      multi_additional: handleDynmaicList(jobData.data?.job_details?.shift),
      component: "autoComplete",
      titleName: "shift",
      inputValue: "shift_value",
      placeholder: "Enter Shift",
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleAutoCompleteKeyDown: handleAutoCompleteKeyDown,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoCompleteChange,
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"} alignItems={"center"}>
          {/* <JobPencilIco />
          <JobStarIco />
          <JobPenIco /> */}
          {getIcons(jobValue?.shift).map((icon) => icon)}
        </CommonGrid2>
      ),
      iconVisible: iconVisible,
    },

    {
      title: "Reports To",
      name: value(jobData.data?.job_details?.reports_to),
      component: "input",
      titleName: "reports_to",
      onChange: handleInputChange,
    },
    {
      title: "BU/Dept/Team",
      name: value(jobData.data?.job_details?.bu_department_team),
      component: "input",
      titleName: "bu_department_team",
      onChange: handleInputChange,
    },
    {
      title: "Company Profile",
      name: jobData.data?.job_details?.company_profile,
      component: "dropDown",
      titleName: "company_profile",
      dropDownData: "available_company_profiles",
      anomaly_content: handleAddIcon(
        jobData.data?.job_details?.company_profile_anomoly,
        jobValue?.company_profile_anomoly,
        { top: "0px", left: "0px" }
      ),
      iconVisible: true,
      handleDropdownChange: handleDropdownChange,
    },
  ];
  const additionalData = [
    ...(alignment === "View"
      ? [
          {
            title: "Highest Level of Education",
            name: jobData.data?.job_details?.education,
            component: "dropDown",
            titleName: "education",
            dropDownData: "available_education",
            check: jobValue.score_education,
            toggleName: "score_education",
            type: "additional",
            handleChangeSwitch: handleChangeSwitch,
            handleDropdownChange: handleDropdownChange,
          },
          {
            title: "Specialization",
            name: jobData.data?.job_details?.specific_degree,
            type: "additional",
            titleName: "specific_degree",
          },
        ]
      : [
          {
            component: "split-part",
            // handleChangeSwitch: handleChangeSwitch,
            // check: jobValue.score_education,
            // toggleName: "score_education",
            type: "additional",
            data: [
              {
                title: "Highest Level of Education",
                name: jobData.data?.job_details?.education,
                component: "dropDown",
                titleName: "education",
                dropDownData: "available_education",
                handleDropdownChange: handleDropdownChange,
              },
              {
                title: "Specialization",
                name: jobData.data?.job_details?.specific_degree,
                component: "input",
                titleName: "specific_degree",
                onChange: handleInputChange,
                handleChangeSwitch: handleChangeSwitch,
                check: jobValue.score_education,
                toggleName: "score_education",
                type: "additional",
              },
            ],
          },
        ]),
    {
      title: "Location Targets",
      multi_additional: handleDynmaicList(
        jobData.data?.job_details?.location_targets
      ),
      component: "autoComplete",
      // check: false,
      titleName: "location_targets",
      inputValue: "location_targets_value",
      placeholder: "Enter Location Targets",
      check: jobValue.score_location_targets,
      toggleName: "score_location_targets",
      type: "additional",
      handleChangeSwitch: handleChangeSwitch,
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleAutoCompleteKeyDown: handleAutoCompleteKeyDown,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoCompleteChange,
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"} alignItems={"center"}>
          {/* <JobPencilIco />
          <JobStarIco />
          <JobPenIco /> */}
          {getIcons(jobValue?.location_targets).map((icon) => icon)}
        </CommonGrid2>
      ),
      iconVisible: iconVisible,
    },
    {
      title: "Certifications",
      multi_additional: handleDynmaicList(
        jobData.data?.job_details?.certificates
      ),
      component: "autoComplete",
      titleName: "certificates",
      inputValue: "certificates_value",
      placeholder: "Enter Certifications",
      check: jobValue.score_certificates,
      toggleName: "score_certificates",
      type: "additional",
      handleChangeSwitch: handleChangeSwitch,
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleAutoCompleteKeyDown: handleAutoCompleteKeyDown,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoCompleteChange,
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"} alignItems={"center"}>
          {/* <JobPencilIco />
          <JobStarIco />
          <JobPenIco /> */}
          {getIcons(jobValue?.certificates).map((icon) => icon)}
        </CommonGrid2>
      ),
      iconVisible: iconVisible,
    },
    {
      title: "Employer Targets",
      component: "autoComplete",
      titleName: "employer_targets",
      inputValue: "employer_targets_value",
      placeholder: "Enter Employer Targets",
      multi_additional: handleDynmaicList(
        jobData.data?.job_details?.employer_targets
      ),
      check: jobValue.score_employer_targets,
      toggleName: "score_employer_targets",
      type: "additional",
      handleChangeSwitch: handleChangeSwitch,
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleAutoCompleteKeyDown: handleAutoCompleteKeyDown,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoCompleteChange,
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"} alignItems={"center"}>
          {/* <JobPencilIco />
          <JobStarIco />
          <JobPenIco /> */}
          {getIcons(jobValue?.employer_targets).map((icon) => icon)}
        </CommonGrid2>
      ),
      iconVisible: iconVisible,
    },
    {
      title: "Languages",
      multi_additional: handleDynmaicList(jobData.data?.job_details?.languages),
      component: "autoComplete",
      titleName: "languages",
      inputValue: "languages_value",
      placeholder: "Enter Languages",
      check: jobValue.score_languages,
      toggleName: "score_languages",
      type: "additional",
      handleChangeSwitch: handleChangeSwitch,
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleAutoCompleteKeyDown: handleAutoCompleteKeyDown,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoCompleteChange,
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"} alignItems={"center"}>
          {/* <JobPencilIco />
          <JobStarIco />
          <JobPenIco /> */}
          {getIcons(jobValue?.languages).map((icon) => icon)}
        </CommonGrid2>
      ),
      iconVisible: iconVisible,
    },
    {
      title: "Visa Status",
      // name: jobData.data?.job_details?.visa_employment_needs?.content,
      component: "multi-complete",
      multi_additional: handleDynmaicList(
        jobData?.data?.job_details?.visa_employment_needs?.content
      ),
      titleName: "visa_status",
      options: "available_visa_status",
      check: jobValue.score_visa,
      toggleName: "score_visa",
      type: "additional",
      placeholder: "Select Visa Status",
      handleChangeSwitch: handleChangeSwitch,
      handleAutoCompleteInputChange: handleAutoCompleteInputChange,
      handleDelete: handleAutoCompleteDelete,
      handleAutoCompleteChange: handleAutoMultiChange,
      content: (
        <CommonGrid2 gap={"10px"} display={"flex"} alignItems={"center"}>
          {getIcons(
            handleDynmaicList(rebuildSourceFromFinalData(jobValue?.visa_status))
          ).map((icon) => icon)}
        </CommonGrid2>
      ),
      iconVisible: iconVisible,
    },
    {
      title: "Government / Security Classification",
      name: jobData.data?.job_details?.govt_security_clearance ? "Yes" : "NO",
      check: jobValue.govt_security_clearance,
      toggleName: "govt_security_clearance",
      type: "additional",
      handleChangeSwitch: handleChangeSwitch,
      size: true,
    },
    {
      title: "DEI",
      name: jobData.data?.job_details?.dei ? "Yes" : "NO",
      check: jobValue.dei,
      toggleName: "dei",
      size: true,
      type: "additional",
      handleChangeSwitch: handleChangeSwitch,
    },
  ];

  const menuItemData = [
    {
      name: "USD",
    },
    { name: "INR" },
  ];

  const handleDeleteSkillRow = (data, values, type) => {
    setDialogData((prev) => ({
      ...prev,
      key: type,
      data: data,
      values: values,
    }));
    setDeleteDialog(true);
  };

  const handleClose = () => {
    if (skillDialog.condition || buttonLoading) {
      setSkillDialog((prev) => ({
        ...prev,
        warning: true,
      }));
    } else {
      setButtonLoading(false);
      setSkillDialog({
        open: false,
        condition: false,
        stayLoading: false,
        leaveLoading: false,
        warning: false,
        disabled: false,
      });
    }
  };

  const handleAddNewSkill = (values) => {
    setSkillDialog((prev) => ({
      ...prev,
      open: true,
      condition: false,
      skillDialog: "",
    }));
    setDialogData({
      title: "Create",
      classification: true,
      // bucketData: jobValue.bucketData,
      experience_in_yrs: "",
      criticality_score: 0,
      skill: "",
      values: values,
    });
  };

  const handleSkillClick = async (values, form, actionType) => {
    if (actionType === "generate") {
      setButtonLoading(true);
      try {
        let payload = {
          id: jobId,
          skill: values.skill,
        };
        const data = await JobSkillDetails(payload);
        setSkillDialog((prev) => ({
          ...prev,
          condition: true,
          ...data?.data,
        }));
        setButtonLoading(false);
      } catch (error) {
        setSnackbarState({
          open: true,
          message: error.message,
          severity: "error",
        });
      }
    } else {
      setButtonLoading(true);
      const currentSkillData = dialogData.values["skillData"];
      const allSkillName = [];
      for (const key in currentSkillData) {
        const skills = currentSkillData[key];

        for (let i = 0; i < skills.length; i++) {
          allSkillName.push(skills[i].skill);
        }
      }
      if (allSkillName.includes(values.skill)) {
        setTimeout(() => {
          setSnackbarState({
            open: true,
            message: "Skill Name already exist",
            severity: "error",
          });
          setButtonLoading(false);
        }, 1000);
      } else {
        setTimeout(() => {
          const skillDataKey = values.key;
          const currentSkillData = dialogData.values["skillData"][skillDataKey];
          const { classification, skill, ...rest } = values;

          const customizeType = {
            ...values,
            type:
              values.type === "extracted_soft_skill" ||
              values.type === "relevant_soft_skill"
                ? "user_added_soft_skill"
                : "user_added_hard_skill",
            key_colors: {
              type: "user_added",
              expertise_level: "user_added",
              experience_in_years: "user_added",
            },
          };
          let updatedSkillData;
          updatedSkillData = [...currentSkillData, customizeType];

          const formData = {
            ...dialogData.values["skillData"],
            [skillDataKey]: updatedSkillData,
          };

          setJobValue((prev) => ({
            ...prev,
            skillData: {
              ...formData,
            },
          }));

          setSnackbarState({
            open: true,
            severity: "success",
            message: "updated Successfully",
          });
          setButtonLoading(false);
          setIsLoading((prev) => ({
            ...prev,
            isLoading: true,
            searchLoading: true,
          }));
          setSkillDialog({
            open: false,
            condition: false,
            stayLoading: false,
            leaveLoading: false,
            warning: false,
            disabled: false,
          });
          setTimeout(() => {
            setIsLoading((prev) => ({
              ...prev,
              isLoading: false,
              searchLoading: false,
            }));
          }, 1000);
        }, 1000);
      }
    }
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };

  const handleDeleteSkill = () => {
    setButtonLoading(true);
    let filterData;
    initialized.current = false;
    setTimeout(() => {
      filterData = dialogData.values["skillData"][dialogData.key].filter(
        (item) => item !== dialogData.data
      );

      const formData = {
        ...dialogData.values["skillData"],
        [dialogData.key]: filterData,
      };

      setJobValue((prev) => ({
        ...prev,
        skillData: {
          ...formData,
        },
      }));

      setSnackbarState({
        open: true,
        severity: "success",
        message: `${
          dialogData?.data?.classification
            ? dialogData?.data?.classification
            : dialogData.data.skill
        } Removed Successfully`,
      });
      setButtonLoading(false);
      handleDeleteDialogClose();
      setIsLoading((prev) => ({
        ...prev,
        isLoading: true,
        searchLoading: true,
      }));
      setTimeout(() => {
        setIsLoading((prev) => ({
          ...prev,
          isLoading: false,
          searchLoading: false,
        }));
      }, 1000);
    }, 1000);
  };

  const fetchJobDataDetail = async (jobId) => {
    try {
      setIsLoading((prev) => ({
        ...prev,
        isLoading: true,
        searchLoading: true,
      }));
      const res = await GET(getJobDataDetail(jobId));
      setJobData((prev) => ({
        ...prev,
        data: res?.data,
      }));
      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
      }));
      dispatch(JobJobFormikData(res?.data, res?.data));
      handleRescoreClose();

      // const data = await JobJobStrategy(jobId);
      // setJobData((prev) => ({
      //   ...prev,
      //   search_strategy: data,
      // }));
      // setIsLoading((prev) => ({
      //   ...prev,
      //   searchLoading: false,
      // }));
    } catch (error) {
      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
        searchLoading: false,
      }));
      handleRescoreClose();
    }
  };

  const fetchJobsList = async (job_id) => {
    setFixLoader(true);
    setIsLoading((prev) => ({
      ...prev,
      isLoading: true,
      searchLoading: true,
    }));
    try {
      const response = await GET(fixedJob(job_id));
      setSnackbarState({
        open: true,
        message: response?.data?.message || "Fix applied successfully",
        severity: "success",
      });
      if (alignment === "Edit") {
        setJobValue(jobModifyData);
        await fetchJobEdit(jobId);
      } else {
        await fetchJobDataDetail(jobId);
      }
      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
        searchLoading: false,
      }));
      setFixLoader(false);
    } catch (err) {
      setSnackbarState({
        open: true,
        message: "An error occurred while applying the fix.",
        severity: "error",
      });

      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
        searchLoading: false,
      }));
      setFixLoader(false);
    }
  };

  //notes
  const handleClickAddNote = () => {
    const rescoreData = JobRescore?.[jobId];

    if (
      rescoreData &&
      rescoreData?.status !== "success" &&
      rescoreData?.status !== "fail"
    ) {
      setReScore((prev) => ({
        ...prev,
        rescore: true,
        file: true,
        reRunOpen: false,
        noteOpen: false,
        disabled: true,
        yesLoading: true,
      }));
    } else {
      setNoteList((prev) => ({
        ...prev,
        open: true,
        loading: false,
        noteId: "",
        type: "",
        note: "",
        created_at: "",
        job_history_reason: "",
        accecpting_less_more_candidates: "",
        locals_only: "",
        hybrid_days: "",
        project_scope: "",
        other_details: "",
        deadline_start: "",
        deadline_end: "",
      }));
      setCheckBox(buildCheckBoxData(resumeTab));
    }
  };

  const handleCloseNoteDialog = () => {
    setNoteList((prev) => ({
      ...prev,
      open: false,
      loading: false,
      noteId: "",
      type: "",
      note: "",
      created_at: "",
      job_history_reason: "",
      accecpting_less_more_candidates: "",
      locals_only: "",
      hybrid_days: "",
      project_scope: "",
      other_details: "",
      deadline_start: "",
      deadline_end: "",
    }));
  };

  const handleDeleteNoteClick = (row, index) => {
    setDeleteNoteDialogOpen(true);
    setNoteList((prev) => ({
      ...prev,
      open: false,
      loading: false,
      noteId: row?.id,
      type: row?.type,
      note: row?.note,
      created_at: row?.created_at,
      job_history_reason: "",
      accecpting_less_more_candidates: "",
      locals_only: "",
      hybrid_days: "",
      project_scope: "",
      other_details: "",
      deadline_start: "",
      deadline_end: "",
    }));
  };

  const handleDeleteNoteDialogClose = () => {
    setDeleteNoteDialogOpen(false);
    handleCloseNoteDialog();
  };

  const handleUpdateNoteClick = (row) => {
    const rescoreData = JobRescore?.[jobId];

    if (
      rescoreData &&
      rescoreData?.status !== "success" &&
      rescoreData?.status !== "fail"
    ) {
      setReScore((prev) => ({
        ...prev,
        rescore: true,
        noteOpen: false,
        file: true,
        reRunOpen: false,
        disabled: true,
        yesLoading: true,
        condition_route: false,
      }));
    } else {
      setNoteList((prev) => ({
        ...prev,
        open: true,
        loading: false,
        noteId: row?.id,
        type: row?.type,
        note: row?.note,
        created_at: row?.created_at,
        job_history_reason: row?.job_history_reason,
        accecpting_less_more_candidates: row?.accecpting_less_more_candidates,
        locals_only: row?.locals_only,
        hybrid_days: row?.hybrid_days,
        project_scope: row?.project_scope,
        other_details: row?.note,
        deadline_start: row?.deadline_start,
        deadline_end: row?.deadline_end,
      }));
      setCheckBox(buildCheckBoxData(resumeTab));
    }
  };

  const fetchNotesTableList = async (jobId) => {
    setNotesTableListLoading(true);
    const res = await GET(getJdNotes(jobId));
    if (res?.success) {
      setNotesTableList(res?.data);
      setNotesTableListLoading(false);
    }
  };

  const handleCreateNote = async (values) => {
    setNoteList((prev) => ({ ...prev, loading: true }));
    let payload;
    if (values.type === "Blank") {
      payload = {
        note: values.note,
        interaction: "Email",
        added_by: "username",
        type: values.type,
      };
    } else {
      payload = {
        note: values.other_details,
        type: values.type,
        added_by: "username",
        hybrid_days: values.hybrid_days,
        deadline_start: values["Date_range"]?.["deadline_start"],
        deadline_end: values["Date_range"]?.["deadline_end"],
        job_history_type: values.job_history_type,
        job_history_reason: values.job_history_reason,
        accecpting_less_more_candidates: values.accecpting_less_more_candidates,
        locals_only: values.locals_only,
        project_scope: values.project_scope,
      };
    }

    if (noteList.noteId) {
      try {
        const res = await PUT(updateJdNote(noteList.noteId), payload);
        setSnackbarState({
          open: true,
          severity: "success",
          message: res?.message,
        });
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.message || "Something went wrong",
        });
      }
    } else {
      try {
        const res = await POST(addJdNotes(jobId), [payload]);
        setSnackbarState({
          open: true,
          severity: "success",
          message: res?.data?.message,
        });
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.message || "Something went wrong",
        });
      }
    }
    handleCloseNoteDialog();
    setReScore((prev) => ({
      ...prev,
      rescore: true,
      noteOpen: true,
      file: false,
      reRunOpen: false,
      condition_route: false,
    }));

    fetchNotesTableList(jobId);
  };

  const handleDeleteNoteById = async () => {
    setNoteList((prev) => ({ ...prev, loading: true }));
    try {
      const res = await DELETE(deleteJdNote(noteList.noteId));
      setSnackbarState({
        open: true,
        severity: "success",
        message: res?.message,
      });
      fetchNotesTableList(jobId);
      handleDeleteNoteDialogClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
      handleCloseNoteDialog();
    }
  };

  const fetchJobEdit = async (jobId) => {
    try {
      setIsLoading((prev) => ({
        ...prev,
        isLoading: true,
        searchLoading: true,
      }));
      await dispatch(JobJobEdit(jobId));
      const usersList = await TeamGetCall();
      setUserData(usersList?.data || []);
      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
        searchLoading: false,
      }));
    } catch (error) {
      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
        searchLoading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  const handleSkillTextChange = (event, rowIndex, values, type, fieldName) => {
    const getData = event.target.value;
    const dataKey = type;
    const updatedSkillData = values?.["skillData"]?.[dataKey]?.map((row) =>
      Array.isArray(row?.skill)
        ? { ...row, skill: row.skill.map((skill) => ({ ...skill })) }
        : { ...row }
    );

    const rowToUpdate = updatedSkillData?.[rowIndex];
    if (rowToUpdate) {
      rowToUpdate[fieldName] = getData;
      rowToUpdate["key_colors"] = {
        ...rowToUpdate?.key_colors,
        experience_in_years: "user_added",
      };
    }

    setJobValue((prev) => ({
      ...prev,
      skillData: {
        ...values?.["skillData"],
        [dataKey]: updatedSkillData,
      },
    }));
  };

  const onSeededDragEnd = (result, setFieldValue, values) => {
    const { destination, source } = result;
    if (!destination) return;
    if (destination.index === source.index) return;
    const update = [...values["pre_screen_questions"]];
    const [removed] = update.splice(source.index, 1);
    update.splice(destination.index, 0, removed);

    setFieldValue("pre_screen_questions", update);
    setJobValue((prev) => ({
      ...prev,
      pre_screen_questions: update,
    }));
  };

  const handleSeededDelete = (question, index, values) => {
    setSeededDialog({
      content: question,
      index: index,
      values: values,
      deleteOpen: true,
      loading: false,
      addOpen: false,
    });
  };

  const handleDeleteSeeded = () => {
    setSeededDialog((prev) => ({
      ...prev,
      loading: true,
    }));

    setTimeout(() => {
      const originalQuestions = [
        ...seededDialog?.values["pre_screen_questions"],
      ];
      const updatedQuestions = originalQuestions.filter(
        (_, i) => i !== seededDialog?.index
      );

      setJobValue((prev) => ({
        ...prev,
        pre_screen_questions: updatedQuestions,
      }));

      setSnackbarState({
        open: true,
        severity: "success",
        message: "Seeded Remvoved Successfully",
      });
      setIsLoading((prev) => ({
        ...prev,
        isLoading: true,
        searchLoading: true,
      }));
      handleSeededClose();

      setTimeout(() => {
        setIsLoading((prev) => ({
          ...prev,
          isLoading: false,
          searchLoading: false,
        }));
      }, 1000);
    }, 1000);
  };

  const handleSeededClose = () => {
    setSeededDialog({
      content: "",
      index: "",
      values: "",
      deleteOpen: false,
      loading: false,
      addOpen: false,
    });
  };
  const ordinalNumbers = [
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "sixth",
    "Seventh",
    "Eigth",
    "Ninth",
    "Tenth",
  ];
  const interviewTypes =
    alignment === "Edit"
      ? jobValue.interview_type
      : jobData.data?.job_details?.interview_type || [];
  const InterviewSettingData = interviewTypes.map((type, index) => ({
    title: `${ordinalNumbers[index] || `${index + 1}th`} Touch`,
    name: value(type),
    component: "input-list",
    titleName: "interview_type",
    onListChange: (value) => handleListChange(value, "interview_type"),
  }));

  const handleAddSeeded = (values) => {
    setSeededDialog((prev) => ({
      ...prev,
      addOpen: true,
      values: values,
    }));
  };

  const handleAddSubmit = (values) => {
    setSeededDialog((prev) => ({
      ...prev,
      loading: true,
    }));

    setTimeout(() => {
      const update = [...seededDialog.values["pre_screen_questions"]];
      const updatedQuestions = [...update, values.question];

      setJobValue((prev) => ({
        ...prev,
        pre_screen_questions: updatedQuestions,
      }));
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Seeded Added Successfully",
      });
      setIsLoading((prev) => ({
        ...prev,
        isLoading: true,
        searchLoading: true,
      }));
      handleSeededClose();

      setTimeout(() => {
        setIsLoading((prev) => ({
          ...prev,
          isLoading: false,
          searchLoading: false,
        }));
      }, 1000);
    }, 1000);
  };

  const noteHeaderData = [
    { name: "Title", direction: "asc", sort: false, width: "50%" },
    { name: "Created By", direction: "asc", sort: false, width: "20%" },
    { name: "Date", direction: "asc", sort: false, width: "15%" },
    { width: "15%" },
  ];

  const handleEnableDynamicCheckBox = (event) => {
    setJobValue((prev) => ({
      ...prev,
      enable_dynamic_pre_screen_questions: event.target.checked,
    }));
  };

  const handleSkillDropDownChange = (e, rowIndex, values, type) => {
    const dataKey = type;
    const getValue = e.target.value;
    const updatedSkillData = values?.["skillData"]?.[dataKey]?.map((row) =>
      Array.isArray(row?.skill)
        ? { ...row, skill: row.skill.map((skill) => ({ ...skill })) }
        : { ...row }
    );

    const rowToUpdate = updatedSkillData?.[rowIndex];
    if (rowToUpdate) {
      rowToUpdate["expertise_level"] = getValue;
      rowToUpdate["key_colors"] = {
        ...rowToUpdate?.key_colors,
        expertise_level: "user_added",
      };
    }

    setJobValue((prev) => ({
      ...prev,
      skillData: {
        ...values?.["skillData"],
        [dataKey]: updatedSkillData,
      },
    }));
  };

  const handleSkillDrag = (result, sourceItems, destinationItems) => {
    if (!result.destination) return;

    const { source, destination } = result;

    const sourceKey = source.droppableId;
    const destinationKey = destination.droppableId;
    setJobValue((prev) => ({
      ...prev,
      skillData: {
        ...prev.skillData,
        [sourceKey]: sourceItems,
        [destinationKey]: destinationItems,
      },
    }));
  };

  const handleAttachment = () => {
    setAttachmentDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleAttachmentClose = () => {
    setAttachmentDialog({
      loading: false,
      disabled: false,
      open: false,
    });
  };

  const handleAttachmentSubmit = async (values, { setFieldValue }) => {
    try {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: false,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: true,
        disabled: true,
      }));

      const formData = new FormData();

      values.file.forEach((fileObj) => {
        formData.append("file", fileObj.file);
      });
      formData.append("name", values.name);
      const data = await JobAttachementCreateCall(jobId, formData);
      await fetchAttachmentTableList(jobId);
      handleAttachmentClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: true,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: false,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleIconClick = (event, rowData) => {
    setAttachmentList((prev) => ({
      ...prev,
      attachementRowData: rowData,
    }));
    setAttachmentAnchorEl(event.currentTarget);
  };

  const handleAttachmentTableBodyData = (row, index) => (
    <>
      <TableCell>
        <CommonGrid2 display={"flex"} gap={"5px"} alignItems={"ceter"}>
          {row.name || "-"}
          {row.is_new && (
            <CustomizeSpan
              background={"#F7F1FF"}
              width="max-content"
              border={"1px solid #EAECF0"}
              padding="2px 8px"
              color={"#6941C6"}
              fontSize="12px"
              fontWeight={700}
              borderRadius="50px"
              display={"flex"}
              alignItems="center"
            >
              Active
            </CustomizeSpan>
          )}
        </CommonGrid2>
      </TableCell>
      <TableCell>{row.type || "-"}</TableCell>
      <TableCell>{row.status || "-"}</TableCell>
      <TableCell>{row.created_by || "-"}</TableCell>
      <TableCell>
        {moment(row.created_at).format("DD MMM YYYY") || "-"}
      </TableCell>
      <TableCell>
        <MoreVertOutlinedIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => handleIconClick(e, row)}
        />

        <CustomizeMenu
          id="basic-menu"
          anchorEl={attachmentAnchorEl}
          open={attachementOpen}
          onClose={() => setAttachmentAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {attachmentMenuData.map((item, index) => (
            <MenuItem
              key={index}
              onClick={item.disabled ? () => {} : item.onClick}
              aria-controls={item.ariaControls}
              aria-haspopup={item.ariaHasPopup}
              aria-expanded={item.ariaExpanded}
              style={{ opacity: item.disabled ? 0.5 : 1 }}
              disabled={item?.disabled}
            >
              <StyledFlexRowView>
                {item.image}
                <Typography>{item.title}</Typography>
              </StyledFlexRowView>
            </MenuItem>
          ))}
        </CustomizeMenu>
      </TableCell>
    </>
  );

  const handelAttachmentDialogClose = () => {
    setDeleteButton({
      loading: false,
      open: false,
      content: "",
      id: "",
    });
  };

  const handleDownloadAttachment = async () => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        download: true,
      }));

      const response = await JobAttachementDownload(
        attachmentList.attachementRowData.id
      );
      let filename = attachmentList.attachementRowData.file_name || "download";
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);

      setAttachmentList((prev) => ({
        ...prev,
        download: false,
      }));
      setAnchorEl(null);
      setAttachmentAnchorEl(null);
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        download: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAttachmentClick = () => {
    setAttachmentAnchorEl(null);
    setDeleteButton((prev) => ({
      ...prev,
      open: true,
      id: attachmentList.attachementRowData.id,
      content: attachmentList.attachementRowData.name,
    }));
  };

  const fetchAttachmentTableList = async (jobId) => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await JobAttachementTableGetCall(jobId);
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
        data: data?.data,
      }));
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAttachment = async () => {
    try {
      setDeleteButton((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await JobAttachementDelete(deleteButton?.id);
      await fetchAttachmentTableList(jobId);
      handelAttachmentDialogClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setDeleteButton((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleFileView = async () => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        view: true,
      }));

      const response = await JobAttachementDownload(
        attachmentList.attachementRowData.id
      );

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        attachmentList.attachementRowData.file_path
      )}`;

      const isDocValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["doc", "docx"].includes(ext);
      };

      const isPdfValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["pdf"].includes(ext);
      };

      if (isDocValidFile(attachmentList.attachementRowData.file_name)) {
        window.open(officeViewerUrl, "_blank");
      } else if (isPdfValidFile(attachmentList.attachementRowData.file_name)) {
        window.open(blobUrl, "_blank");
      }
      setAnchorEl(null);
      setAttachmentList((prev) => ({
        ...prev,
        view: false,
      }));
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        view: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const attachmentMenuData = [
    {
      title: "View",
      disabled: attachmentList.view || attachmentList.download,
      image: attachmentList.view ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <EyeIco />
      ),
      onClick: () => {
        handleFileView();
      },
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      disabled: attachmentList.download || attachmentList.view,
      onClick: handleDeleteAttachmentClick,
    },
    {
      title: "Download",
      disabled: attachmentList.download || attachmentList.view,
      image: attachmentList.download ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "20px" }} />
      ),
      onClick: handleDownloadAttachment,
    },
  ];

  const accordionDataView = [
    {
      title: "Primary Information",
      component: (
        <Fragment>
          {alignment === "View" ? (
            <CommonCard
              viewData={primaryViewData}
              loading={isLoading.isLoading}
              iconVisible={iconVisible}
              key_colors={jobValue?.key_colors}
            />
          ) : (
            <EditIndex
              editData={primaryViewData}
              menuItemData={menuItemData}
              loading={isLoading.isLoading}
              iconVisible={iconVisible}
            />
          )}
          <CommonGrid2 margin={"4rem 0rem 0rem"}>
            <Typography variant="h4" margin={"0rem 0px 2rem"} fontWeight={600}>
              {"Secondary Information"}
            </Typography>
            {alignment === "View" ? (
              <CommonCard
                viewData={SecondaryViewData}
                loading={isLoading.isLoading}
                iconVisible={iconVisible}
                key_colors={jobValue?.key_colors}
              />
            ) : (
              <EditIndex
                editData={SecondaryViewData}
                loading={isLoading.isLoading}
                iconVisible={iconVisible}
              />
            )}

            {alignment === "View" ? (
              <CommonCard
                viewData={additionalData}
                loading={isLoading.isLoading}
                viewMarginTop={"1rem"}
                iconVisible={iconVisible}
                key_colors={jobValue?.key_colors}
              />
            ) : (
              <EditIndex
                marginTop={"3rem"}
                editData={additionalData}
                loading={isLoading.isLoading}
                iconVisible={iconVisible}
              />
            )}
          </CommonGrid2>
        </Fragment>
      ),
    },
    {
      title: "Skills",
      component: (
        <CommonGrid2 spacing={3} container>
          <CommonGrid2 size={12}>
            <Skill
              highPriority={
                alignment === "Edit"
                  ? jobValue?.skillData?.high_priority
                  : jobData.data?.job_details?.high_priority
              }
              lowPriority={
                alignment === "Edit"
                  ? jobValue?.skillData?.low_priority
                  : jobData.data?.job_details?.low_priority
              }
              mediumPriority={
                alignment === "Edit"
                  ? jobValue?.skillData?.medium_priority
                  : jobData.data?.job_details?.medium_priority
              }
              recommended={
                alignment === "Edit"
                  ? jobValue?.skillData?.recommended
                  : jobData.data?.job_details?.recommended
              }
              alignment={alignment}
              jobData={jobData.data}
              isLoading={isLoading.isLoading}
              handleAddNewSkill={handleAddNewSkill}
              jobModifyData={jobModifyData}
              handleSkillDropDownChange={handleSkillDropDownChange}
              handleSkillTextChange={handleSkillTextChange}
              handleDeleteSkillRow={handleDeleteSkillRow}
              handleSkillDrag={handleSkillDrag}
              iconVisible={iconVisible}
              initialized={initialized}
            />
          </CommonGrid2>
        </CommonGrid2>
      ),
    },
    {
      title: "Interview Settings",
      component: (
        <CommonGrid2 spacing={3} container>
          {jobData.data &&
            jobData.data?.job_details &&
            jobData.data?.job_details?.interview_type?.length !== 0 && (
              <CommonGrid2 size={12}>
                <InterviewSettings
                  InterviewSettingData={InterviewSettingData}
                  alignment={alignment}
                  isLoading={isLoading.isLoading}
                  rowSize={true}
                />
              </CommonGrid2>
            )}
          {(alignment === "Edit"
            ? true
            : jobData.data &&
              jobData.data?.job_details &&
              jobData.data?.job_details?.pre_screen_questions?.length !==
                0) && (
            <CommonGrid2 size={12}>
              <SeededPreScreen
                alignment={alignment}
                preScreen={jobData.data?.job_details?.pre_screen_questions}
                onDragEnd={onSeededDragEnd}
                handleSeededDelete={handleSeededDelete}
                isLoading={isLoading.isLoading}
                onListChange={handleListChange}
                handleAddSeeded={handleAddSeeded}
                handleEnableDynamicCheckBox={handleEnableDynamicCheckBox}
              />
            </CommonGrid2>
          )}
        </CommonGrid2>
      ),
    },
    {
      title: "Notes",
      component: (
        <Notes
          handleClickAddNote={handleClickAddNote}
          handleDeleteNoteClick={handleDeleteNoteClick}
          handleUpdateNoteClick={handleUpdateNoteClick}
          notesTableList={notesTableList}
          notesTableListLoading={notesTableListLoading || isLoading.isLoading}
          isLoading={isLoading.isLoading}
          headerData={noteHeaderData}
          disabled={
            jobStatus === "Closed" ||
            jobStatus === "Cancelled" ||
            jobStatus === "Filled"
          }
        />
      ),
    },

    {
      title: "",
      component: (
        <Attachment
          tableData={attachmentList?.data}
          attachementHeaderData={attachementHeaderData}
          handleAttachment={handleAttachment}
          handleAttachmentTableBodyData={handleAttachmentTableBodyData}
          isLoading={isLoading.isLoading || attachmentList.loading}
        />
      ),
    },
  ];

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleSubmitJob = async (values, actions) => {
    setIsLoading((prev) => ({
      ...prev,
      isLoading: true,
      searchLoading: true,
    }));
    setEditButtonLoading(true);

    const result = (valueData) => {
      if (!valueData) return [];

      const processedData = valueData.reduce((acc, { name, content }) => {
        const existing = acc.find((item) => item.name === name);
        if (existing) {
          existing.content.push(content);
        } else {
          acc.push({ name, content: [content] });
        }
        return acc;
      }, []);

      const extracted = processedData.find((item) => item.name === "extracted");
      const inferred = processedData.find((item) => item.name === "inferred");
      const userAdded = processedData.find(
        (item) => item.name === "user_added"
      );

      const resultData = [];
      if (!extracted) {
        resultData.push({ name: "extracted", content: [] });
      } else {
        resultData.push(extracted);
      }
      if (!inferred) {
        resultData.push({ name: "inferred", content: [] });
      } else {
        resultData.push(inferred);
      }
      const otherData = processedData.filter(
        (item) =>
          item.name !== "extracted" &&
          item.name !== "inferred" &&
          item.name !== "user_added"
      );
      resultData.push(...otherData);
      if (!userAdded) {
        resultData.push({ name: "user_added", content: [] });
      } else {
        resultData.push(userAdded);
      }
      return resultData;
    };

    const data = {
      ...JobJobEditData,
      ...values,
      submission_deadline: values?.submission_deadline || null,
      employer_targets: result(values.employer_targets),
      certificates: result(values.certificates),
      languages: result(values.languages),
      shift: result(values.shift),
      visa_status: rebuildSourceFromFinalData(values.visa_status),
      location_targets: result(values.location_targets),
      high_priority: values.skillData.high_priority,
      low_priority: values.skillData.low_priority,
      medium_priority: values.skillData.medium_priority,
      recommended: values.skillData.recommended,
      industry: rebuildSourceFromFinalData(values.industry),
      job_owner: values?.job_owner?.id || values?.job_owner?.user_id || "",
      account_executive:
        values?.account_executive?.id ||
        values?.account_executive?.user_id ||
        "",
      required_years_for_industry: {
        months: JobJobEditData.required_years_for_industry?.months,
        years: parseInt(values.required_years_for_industry),
      },
    };

    try {
      dispatch(JobJobFormikData(values, values));
      const jobEdit = await JobJobSubmit(jobValue.id, data);
      if (values.job_title && onTitleUpdate) {
      onTitleUpdate(values.job_title);
    }
      setSnackbarState({
        open: true,
        severity: "success",
        message: jobEdit.message,
      });
      setAlignment("View");
      // setIsLoading(false);
      setEditButtonLoading(false);
    } catch (error) {
      dispatch(JobJobFormikData(jobValue, values));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
        searchLoading: false,
      }));
      setEditButtonLoading(false);
    }
  };

  const handleKeepAsDraft = async ({ condition }) => {
    setReviewInfo((prev) => ({
      ...prev,
      disabled: true,
      draftLoading: condition ? false : true,
      rescoreLoading: condition ? true : false,
    }));

    const result = (valueData) => {
      if (!valueData) return [];

      const processedData = valueData.reduce((acc, { name, content }) => {
        const existing = acc.find((item) => item.name === name);
        if (existing) {
          existing.content.push(content);
        } else {
          acc.push({ name, content: [content] });
        }
        return acc;
      }, []);

      const extracted = processedData.find((item) => item.name === "extracted");
      const inferred = processedData.find((item) => item.name === "inferred");
      const userAdded = processedData.find(
        (item) => item.name === "user_added"
      );

      const resultData = [];
      if (!extracted) {
        resultData.push({ name: "extracted", content: [] });
      } else {
        resultData.push(extracted);
      }
      if (!inferred) {
        resultData.push({ name: "inferred", content: [] });
      } else {
        resultData.push(inferred);
      }
      const otherData = processedData.filter(
        (item) =>
          item.name !== "extracted" &&
          item.name !== "inferred" &&
          item.name !== "user_added"
      );
      resultData.push(...otherData);
      if (!userAdded) {
        resultData.push({ name: "user_added", content: [] });
      } else {
        resultData.push(userAdded);
      }
      return resultData;
    };

    const data = {
      ...JobJobEditData,
      ...jobValue,
      submission_deadline: jobValue?.submission_deadline || null,
      employer_targets: result(jobValue.employer_targets),
      certificates: result(jobValue.certificates),
      languages: result(jobValue.languages),
      visa_status: rebuildSourceFromFinalData(jobValue.visa_status),
      shift: result(jobValue.shift),
      location_targets: result(jobValue.location_targets),
      high_priority: jobValue.skillData.high_priority,
      low_priority: jobValue.skillData.low_priority,
      medium_priority: jobValue.skillData.medium_priority,
      recommended: jobValue.skillData.recommended,
      // industry: jobValue.industry.map((item) => item.name),
      industry: rebuildSourceFromFinalData(jobValue.industry),
      job_owner: jobValue?.job_owner?.id || jobValue?.job_owner?.user_id || "",
      account_executive:
        jobValue?.account_executive?.id ||
        jobValue?.account_executive?.user_id ||
        "",
      required_years_for_industry: {
        months: JobJobEditData.required_years_for_industry?.months,
        years: parseInt(jobValue.required_years_for_industry),
      },
    };

    try {
      dispatch(JobJobFormikData(jobValue, jobValue));
      const jobEdit = await JobJobSubmit(jobValue.id, data);
      setSnackbarState({
        open: true,
        severity: "success",
        message: jobEdit.message,
      });
      if (alignment === "Edit") {
        setAlignment("View");
        if (condition) {
          handleClickRerun();
        }
        setReviewInfo((prev) => ({
          ...prev,
          open: false,
          disabled: false,
          rescoreLoading: false,
          draftLoading: false,
        }));
      } else {
        await fetchJobDataDetail(jobId);
        await fetchAttachmentTableList(jobId);
        if (condition) {
          handleClickRerun();
        }
        setReviewInfo((prev) => ({
          ...prev,
          open: false,
          disabled: false,
          rescoreLoading: false,
          draftLoading: false,
        }));

        setJobValue(jobModifyData);
        await fetchJobEdit(jobId);
      }
    } catch (error) {
      dispatch(JobJobFormikData(jobValue, jobValue));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setReviewInfo((prev) => ({
        ...prev,
        disabled: false,
        draft: false,
      }));
    }
  };

  const handleScrollToError = (data) => {
    const errorKeys = Object.keys(data);
    if (errorKeys.includes("skillData")) {
      setCardValue({ value: 1, prev: cardValue.prev });
    }
    // else if (errorKeys.includes("relevancy_index_anomoly")) {
    //   setCardValue({ value: 0, prev: cardValue.prev });
    // }
    else if (
      errorKeys.includes("pre_screen_questions") ||
      errorKeys.includes("enable_dynamic_pre_screen_questions")
    ) {
      setCardValue({ value: 2, prev: cardValue.prev });
    } else {
      setCardValue({
        value:
          (cardData.findIndex((item) => !item.disabled) ?? -1) !== -1
            ? cardData.findIndex((item) => !item.disabled)
            : 0,
        prev: cardValue.prev,
      });
    }
    setTimeout(() => {
      const errorElement = document.querySelector(".Mui-error");
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 0);
  };

  const Footer = () => {
    return (
      <CommonGrid2 display={"flex"} gap={"1rem"}>
        {reScore.reRunOpen ? (
          <CommonButton
            value={"Rescore"}
            width={"100%"}
            padding={"10px"}
            marginTop={reScore.noteOpen ? "2rem" : "1rem"}
            fontWeight={"700"}
            fontSize={"15px"}
            disabled={reScore.disabled}
            loading={reScore.yesLoading}
            onClick={() => handleClickScore("re-run", false)}
          />
        ) : (
          <>
            <CommonButton
              value={"No"}
              variant="outlined"
              color="#344054"
              width={"100%"}
              padding={"10px"}
              marginTop={"1rem"}
              fontWeight={"700"}
              fontSize={"15px"}
              border={"#D0D5DD"}
              onClick={() => handleClickScore("no", reScore.reRunOpen)}
              disabled={reScore.disabled}
              loading={reScore.noLoading}
            />

            <CommonButton
              value={"Yes"}
              width={"100%"}
              padding={"10px"}
              marginTop={"1rem"}
              fontWeight={"700"}
              fontSize={"15px"}
              disabled={reScore.disabled}
              loading={reScore.yesLoading}
              onClick={() => handleClickScore("yes", reScore.reRunOpen)}
            />
          </>
        )}
      </CommonGrid2>
    );
  };

  const ConfirmationButton = () => {
    return (
      <CommonGrid2 display={"flex"} gap={"1rem"} marginTop={"2rem"}>
        <CommonButton
          value={"Cancel"}
          variant="outlined"
          color="#344054"
          width={"100%"}
          padding={"10px"}
          fontWeight={"700"}
          fontSize={"15px"}
          border={"#D0D5DD"}
          onClick={() => handleClickScore("no", reScore.reRunOpen)}
          disabled={reScore.disabled}
          loading={reScore.noLoading}
        />

        <CommonButton
          value={"Yes"}
          width={"100%"}
          padding={"10px"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={reScore.disabled}
          loading={reScore.yesLoading}
          onClick={() => handleClickScoreConfirmation("yes")}
        />
      </CommonGrid2>
    );
  };

  const handleClickScoreConfirmation = (condition) => {
    if (condition === "yes") {
      setReScore((prev) => ({
        ...prev,
        disabled: true,
        yesLoading: true,
      }));
      setTimeout(() => {
        setReScore((prev) => ({
          ...prev,
          disabled: false,
          noLoading: false,
          yesLoading: false,
          reRunOpen: false,
          noteOpen: false,
          file: false,
        }));
      }, 1000);
    }
  };

  const handleClickScore = async (condition, check) => {
    const checkValue = checkBox.some((item) => item.value === true);
    const checkChilValue = checkBox.some(
      (item) =>
        item.child && item.child.some((children) => children.value === true)
    );

    const jobCheck = checkBox.find(
      (item) => item.title === "Job Description"
    )?.value;

    if (!checkValue && !checkChilValue && condition !== "no") {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "Please select at least one item to proceed",
      });
    } else if ((!checkValue || !jobCheck) && condition !== "no") {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "Please select the Job description to proceed",
      });
    } else {
      setReScore((prev) => ({
        ...prev,
        yesLoading:
          condition === "yes" || condition === "re-run" ? true : false,
        noLoading: condition === "no" ? true : false,
        disabled: true,
        file: true,
      }));

      setIsLoading((prev) => ({
        ...prev,
        isLoading: true,
        searchLoading: true,
      }));

      let params = {
        score: condition === "re-run" || condition === "yes" ? true : false,
      };

      let checkData = checkBox.flatMap((item) => {
        if (item.title === "Job Description" && item.value) {
          return [
            {
              ...item,
              type: "JobDescription.docx",
              progress: 0,
              buffer: 0,
              visible: false,
            },
          ];
        }

        if (item.child && Array.isArray(item.child)) {
          return item.child
            .filter((child) => child.value)
            .map((child) => ({
              ...child,
              progress: 0,
              buffer: 0,
              type: child.file_name,
              visible: false,
            }));
        }

        return [];
      });
      let payload = {
        job: checkBox.find((item) => item.title === "Job Description").value,
        resumes: checkBox
          .filter((item) => Array.isArray(item.child))
          .flatMap(
            (item) => item.child && item.child.filter((child) => child.value)
          ),
      };
      if (condition === "re-run" || condition === "yes") {
        const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};

        const updated = {
          ...existing,
          [jobId]: {
            ...existing[jobId],
            data: checkData,
            status: "process",
          },
        };

        localStorage.setItem("JobRescore", JSON.stringify(updated));
        dispatch(
          JobJobRescore({
            id: jobId,
            data: updated[jobId].data,
            status: "process",
          })
        );
      } else {
        dispatch(JobJobRescore({ id: jobId, data: [], status: "fail" }));
      }

      try {
        const response = await JobJobReScore(jobId, params, payload);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;

          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(jsonResponse, condition);
            } catch (e) {
              const storedData = JSON.parse(
                localStorage.getItem("JobRescore")
              )?.[jobId];
              const getData = storedData?.data?.map((f) =>
                f.title === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      message: e.message,
                    }
                  : { ...f }
              );

              const existing =
                JSON.parse(localStorage.getItem("JobRescore")) || {};
              localStorage.setItem(
                "JobRescore",
                JSON.stringify({
                  ...existing,
                  [jobId]: {
                    data: getData,
                    status: "",
                  },
                })
              );

              dispatch(
                JobJobRescore({ id: jobId, data: getData, status: "fail" })
              );

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setIsLoading((prev) => ({
                ...prev,
                isLoading: false,
                searchLoading: false,
              }));
              setReScore({
                noLoading: false,
                disabled: false,
                yesLoading: false,
                rescore: true,
                reRunOpen: condition === "re-run" ? true : false,
                noteOpen: false,
                file: true,
                condition_route: false,
              });
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse, condition);
          } catch (e) {
            const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
              jobId
            ];
            const getData = storedData?.data?.map((f) =>
              f.title === jsonResponse.data.current_resume
                ? {
                    ...f,
                    visible: true,
                    delete: true,
                    message: e.message,
                  }
                : { ...f, delete: true, message: e.message }
            );

            const existing =
              JSON.parse(localStorage.getItem("JobRescore")) || {};
            localStorage.setItem(
              "JobRescore",
              JSON.stringify({
                ...existing,
                [jobId]: {
                  data: getData,
                  status: "",
                },
              })
            );

            dispatch(
              JobJobRescore({ id: jobId, data: getData, status: "fail" })
            );

            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
            setIsLoading((prev) => ({
              ...prev,
              isLoading: false,
              searchLoading: false,
            }));
            setReScore({
              noLoading: false,
              disabled: false,
              yesLoading: false,
              rescore: true,
              reRunOpen: condition === "re-run" ? true : false,
              noteOpen: false,
              file: true,
              condition_route: false,
            });
          }
        }
      } catch (error) {
        const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
          jobId
        ];
        const getData = storedData?.data?.map((f) => ({
          ...f,
          visible: true,
          message: "Error during the request",
        }));
        const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
        localStorage.setItem(
          "JobRescore",
          JSON.stringify({
            ...existing,
            [jobId]: {
              data: getData,
              status: "",
            },
          })
        );

        dispatch(JobJobRescore({ id: jobId, data: getData, status: "fail" }));

        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });
        setIsLoading((prev) => ({
          ...prev,
          isLoading: false,
          searchLoading: false,
        }));
        setReScore({
          noLoading: false,
          disabled: false,
          yesLoading: false,
          rescore: true,
          reRunOpen: condition === "re-run" ? true : false,
          noteOpen: false,
          file: true,
          condition_route: false,
        });
      }
    }
  };

  const processJsonResponse = async (jsonResponse, condition) => {
    const { success, data, message } = jsonResponse;

    if (success && data?.percent !== undefined) {
      const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
        jobId
      ];
      const getData = storedData?.data?.map((f) =>
        f.title === data.current_resume
          ? {
              ...f,
              progress: data.percent,
              buffer: data.percent,
              visible: false,
              progress_message: data.progress_message,
            }
          : f
      );
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: getData,
            status: "process",
          },
        })
      );
      dispatch(JobJobRescore({ id: jobId, data: getData, status: "process" }));
    } else if (data?.response) {
      if (reScore.condition_route) {
        setAlignment("Edit");
      } else {
        await fetchData();
        await fetchJobDataDetail(jobId);
        await fetchJobEdit(jobId);
      }
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: [],
            status: "success",
          },
        })
      );
      dispatch(JobJobRescore({ id: jobId, data: [], status: "success" }));
      handleRescoreClose();

      setSnackbarState({
        open: true,
        severity: "success",
        message: message,
        // duration: 500,
      });
    } else if (!success) {
      const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
        jobId
      ];
      const getData = storedData?.data?.map((f) =>
        f.title === data.current_resume || data.length === 0
          ? {
              ...f,
              visible: true,
              message: message,
            }
          : { ...f, delete: true }
      );
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: getData,
            status: "",
          },
        })
      );

      dispatch(JobJobRescore({ id: jobId, data: getData, status: "fail" }));

      setIsLoading((prev) => ({
        ...prev,
        isLoading: false,
        searchLoading: false,
      }));
      setReScore({
        noLoading: false,
        disabled: false,
        yesLoading: false,
        rescore: true,
        reRunOpen: condition === "re-run" ? true : false,
        noteOpen: false,
        file: true,
        condition_route: false,
      });
    }
  };

  const handleRescoreClose = () => {
    setIsLoading((prev) => ({
      ...prev,
      isLoading: false,
    }));
    setReScore({
      noLoading: false,
      disabled: false,
      yesLoading: false,
      rescore: false,
      reRunOpen: false,
      noteOpen: false,
      file: false,
      condition_route: false,
    });
    setCheckBox(buildCheckBoxData(resumeTab));
  };

  useEffect(() => {
    if (JobRescore && JobRescore?.[jobId]?.status === "success") {
      handleRescoreClose();
    }
  }, [JobRescore]);

  const handleClickRerun = async () => {
    setBackGroundprocess((prev) => ({
      ...prev,
      openLoading: true,
    }));
    try {
      const rescoreData = JobRescore && JobRescore?.[jobId];

      if (
        rescoreData &&
        rescoreData?.status !== "success" &&
        rescoreData?.status !== "fail"
      ) {
        setReScore((prev) => ({
          ...prev,
          rescore: true,
          noteOpen: false,
          file: true,
          reRunOpen: true,
          disabled: true,
          yesLoading: true,
        }));
        setBackGroundprocess((prev) => ({
          ...prev,
          open: false,
          openLoading: false,
        }));
      } else {
        const data = await checkBackGroundProcess(jobId);
        if (!data?.background_process_status) {
          setReScore({
            noLoading: false,
            disabled: false,
            yesLoading: false,
            rescore: true,
            reRunOpen: true,
            noteOpen: false,
            file: false,
            condition_route: false,
          });
        }
        setBackGroundprocess((prev) => ({
          ...prev,
          open: data?.background_process_status,
          openLoading: false,
        }));
      }
    } catch (error) {
      setBackGroundprocess((prev) => ({
        ...prev,
        openLoading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };
  const resultHeaderData = [
    {
      name: "Relevancy Index",
      icon: handleAddIcon(
        jobData.data?.job_details?.relevancy_index_anomoly,
        jobValue.relevancy_index_anomoly,
        { top: "4px", left: "10px" }
      ),
    },
    {},
    { name: "Relevancy Score" },
    {},
  ];

  const onRelevancyDragEnd = (result, values, setFieldValue) => {
    const { source, destination } = result;
    if (!destination || destination.index === source.index) return;
    const reorderedCandidates = [...values["relevancy_index"]];
    const [removed] = reorderedCandidates.splice(source.index, 1);
    reorderedCandidates.splice(destination.index, 0, removed);
    setFieldValue("relevancy_index", reorderedCandidates);
    setJobValue((prev) => ({
      ...prev,
      relevancy_index: reorderedCandidates,
    }));
  };

  const noteUpperData = [
    {
      title: "Client",
      component: "input",
      fontSize: "15px",
      value: jobData.data?.job_details?.company_name,
      placeholderFontSize: "15px",
      placeholder: "Enter the name",
    },
    {
      title: "Date",
      component: "input",
      fontSize: "15px",
      value: moment(today).format("DD MMM YYYY"),
      placeholderFontSize: "15px",
      placeholder: "Enter the number",
    },
    {
      title: "Position",
      fontSize: "15px",
      value: jobData.data?.job_details?.job_title,
      placeholderFontSize: "15px",
      placeholder: "Enter H1B Holder Company Name",
    },
    {
      title: "Job ID",
      fontSize: "15px",
      value: jobData.data?.job_details?.req_id,
      placeholderFontSize: "15px",
      placeholder: "Enter H1B Holder Company Name",
    },
  ];

  const isAllVerified = cardData.every((item) => item.status === "Verified");

  const validationSchema = Yup.object().shape({
    job_title: Yup.string().required("Job title is required"),
    company_name: Yup.string().required("Company name is required"),
    pay_rate: Yup.object().shape({
      min: Yup.number()
        .typeError("Minimum pay rate must be a number")
        .min(0, "Minimum pay rate cannot be negative")
        .nullable(),
      max: Yup.number()
        .typeError("Maximum pay rate must be a number")
        .nullable()
        .when("min", (min, schema) =>
          min !== undefined && min !== null
            ? schema.moreThan(
                min,
                "Maximum pay rate must be greater than the minimum"
              )
            : schema
        ),
    }),

    location_targets: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          content: Yup.string(),
          id: Yup.mixed(),
        })
      )
      .test(
        "unique-content",
        "Location content must be unique",
        function (value) {
          if (!value) return true;
          const contentSet = new Set();
          for (let location of value) {
            if (location.content) {
              const lowercasedContent = location.content.toLowerCase();
              if (contentSet.has(lowercasedContent)) {
                return false;
              }
              contentSet.add(lowercasedContent);
            }
          }
          return true;
        }
      ),
    pre_screen_questions: Yup.array()
      .of(
        Yup.string()
          .test(
            "no-empty-string",
            "Empty strings are not allowed",
            (value) => value !== "" && value !== undefined
          )
          .required("This field is required")
      )
      .nullable()
      .optional(),
    skillData: Yup.object({
      high_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
      medium_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
      low_priority: Yup.array().of(
        Yup.object({
          skill: Yup.string().required("Skill is required"),
          experience_in_yrs: Yup.number()
            .required("Experience is required")
            .typeError("Please enter a valid number")
            .integer("Experience must be an integer"),
        })
      ),
    }),
    start_date: Yup.string()
  .nullable()
  .test(
    "start-before-end",
    "Start date cannot be after end date",
    function (value) {
      const { end_date } = this.parent;

      if (!value || !end_date) return true;

      const s = dayjs(value, "DD MMM YYYY");
      const e = dayjs(end_date, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !s.isAfter(e, "day");
    }
  )
  .test(
    "start-not-same",
    "Start date and end date cannot be the same",
    function (value) {
      const { end_date } = this.parent;

      if (!value || !end_date) return true;

      const s = dayjs(value, "DD MMM YYYY");
      const e = dayjs(end_date, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !s.isSame(e, "day");
    }
  ),

end_date: Yup.string()
  .nullable()
  .test(
    "end-after-start",
    "End date cannot be before start date",
    function (value) {
      const { start_date } = this.parent;

      if (!value || !start_date) return true;

      const s = dayjs(start_date, "DD MMM YYYY");
      const e = dayjs(value, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !e.isBefore(s, "day");
    }
  )
  .test(
    "end-not-same",
    "Start date and end date cannot be the same",
    function (value) {
      const { start_date } = this.parent;

      if (!value || !start_date) return true;

      const s = dayjs(start_date, "DD MMM YYYY");
      const e = dayjs(value, "DD MMM YYYY");

      if (!s.isValid() || !e.isValid()) return true;

      return !e.isSame(s, "day");
    }
  ),
    marked_as_verified: Yup.boolean().oneOf(
      [!isAllVerified],
      "All sections must be verified before proceeding."
    ),
  });

  const WholeProgressView = () => {
    return (
      <CommonGrid2 margin={"1.5rem 0px 1rem"}>
        {JobRescore &&
          JobRescore[jobId]?.data &&
          JobRescore[jobId]?.data?.map((file, index) => (
            <FileContainer
              key={index}
              elevation={1}
              gap={"1rem"}
              padding={"6px 10px 3px"}
              margin="16px 0px 0px"
              borderRadius="7px"
            >
              <Box display={"flex"} alignItems={"flex-start"} width={"20px"}>
                <GetFileIcon file={file} />
              </Box>

              <Box width={"100%"}>
                <CommonGrid2 display={"flex"} alignItems={"center"} gap={"5px"}>
                  <Typography
                    color="#344054"
                    fontSize={"14px"}
                    fontWeight={700}
                    textAlign={"start"}
                  >
                    {file.title}
                  </Typography>
                  <CustomizeSpan
                    background={
                      file.record_type === "GOLDEN RECORD"
                        ? "#DAFDF5"
                        : "#F7F1FF"
                    }
                    width="max-content"
                    border={
                      file.record_type === "GOLDEN RECORD"
                        ? "1px solid #C3FFF1"
                        : "1px solid #EAECF0"
                    }
                    padding="2px 10px"
                    color={
                      file.record_type === "GOLDEN RECORD"
                        ? "#049F9A"
                        : "#6941C6"
                    }
                    fontSize="11px"
                    fontWeight={700}
                    borderRadius="50px"
                  >
                    {file.record_type
                      ?.toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}
                  </CustomizeSpan>
                </CommonGrid2>
                <Typography color="#475467" fontSize={"14px"} fontWeight={500}>
                  {file.size}
                </Typography>
                {file.progress >= 0 && (
                  <CommonTippy
                    content={file.message}
                    visible={file.visible}
                    interactive={true}
                    trigger="click"
                    hideOnClick={false}
                    zIndex={2}
                    color="red"
                  >
                    <CustomDiv textAlign="left">
                      <StyledLinearContainer>
                        <CommonLinearProgress
                          variant={
                            file.progress && !file.visible
                              ? "buffer"
                              : "determinate"
                          }
                          value={file.progress}
                          valueBuffer={file.buffer}
                          height={"6px"}
                          left="0px"
                          borderRadius={"2px"}
                          backgroundColor={"#E0E0E0"}
                          barbackgroundColor={file.visible ? "red" : "#7F56D9"}
                          dashedmarginTop={"1px"}
                          dashedbackgroundImage={
                            file.visible
                              ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                              : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                          }
                        />

                        <Typography
                          color="#344054"
                          fontSize={"14px"}
                          fontWeight={500}
                        >
                          {file.progress}%
                        </Typography>
                      </StyledLinearContainer>
                      {file.progress_message && (
                        <CustomizeSpan
                          fontSize="12px"
                          color="#475467"
                          sx={{
                            letterSpacing: "0.2px",
                            animation: "wave 1.5s ease-in-out infinite",
                            "@keyframes wave": {
                              "0%, 100%": { transform: "translateY(0)" },
                              "50%": { transform: "translateY(-4px)" },
                            },
                          }}
                        >
                          {file.progress_message} . . .
                        </CustomizeSpan>
                      )}
                    </CustomDiv>
                  </CommonTippy>
                )}
              </Box>
            </FileContainer>
          ))}
      </CommonGrid2>
    );
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      label: "Share Job",
      icon: <ShareIco />,
      disabled:
        isLoading.isLoading ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      onClick: () => {
        handleShareClick();
        handleMenuClose();
      },
    },

    {
      label: "Add Note",
      disabled:
        isLoading.isLoading ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      icon: <ClipBoardCheck />,
      onClick: () => {
        handleClickAddNote();
        handleMenuClose();
      },
    },

    {
      label: "Download",
      icon: <Download sx={{ fontSize: "16px" }} />,
      disabled: isLoading.isLoading,
      onClick: () => {
        handleDownloadJdOpen();
        handleMenuClose();
      },
    },
  ];

  const handleShareClick = () => {
    setShareDialogOpen({ open: true, loading: false });
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen({ open: false, loading: false });
  };

  const handleShareInvite = async (shareData) => {
    setShareDialogOpen((prev) => ({ ...prev, loading: true }));
    try {
      let payload = {
        url: window.location.href,
        to_mail: shareData,
        cc_mail: [],
        job_id: jobId,
        job_name: jobData.data?.job_details?.job_title || "",
      };
      const data = await JobJobShare(payload, "Job", jobId);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      handleShareDialogClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setShareDialogOpen((prev) => ({ ...prev, loading: false }));
    }
  };

  const handlebackGroundWarningClose = () => {
    setBackGroundprocess({
      open: false,
      openLoading: false,
      buttonLoading: false,
    });
  };

  const handlebackGroundWarning = () => {
    setBackGroundprocess((prev) => ({
      ...prev,
      buttonLoading: true,
    }));
    setTimeout(() => {
      handlebackGroundWarningClose();
    }, 1000);
  };

  const BackGroundFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"OK"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        onClick={handlebackGroundWarning}
        disabled={backGroundprocess.buttonLoading}
        loading={backGroundprocess.buttonLoading}
      />
    </CommonGrid2>
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      if (alignment === "Edit" || reviewInfo.open) {
        const clonedJobValue = JSON.parse(JSON.stringify(jobValue));
        const clonedJobValidationCheck = JSON.parse(
          JSON.stringify(jobValidationCheck)
        );
        let getValues = {
          ...clonedJobValidationCheck,
          shift_value: "",
          location_targets_value: "",
          certificates_value: "",
          employer_targets_value: "",
          languages_value: "",
        };

        const getChangedKeys = (a, b) => {
          return Object.keys(a).filter(
            (key) => JSON.stringify(a[key]) !== JSON.stringify(b[key])
          );
        };

        const changedKeys = getChangedKeys(jobValue, jobValidationCheck);
        setCardData((prev) =>
          prev.map((item, index) => {
            if (changedKeys.length === 0) {
              return {
                ...item,
                status: "Verified",
                disabled: true,
                loading: false,
              };
            } else if (changedKeys.includes("skillData") && index === 1) {
              return {
                ...item,
                status: "Review Pending",
                disabled: false,
                loading: false,
              };
            } else if (
              (changedKeys.includes("pre_screen_questions") ||
                changedKeys.includes("enable_dynamic_pre_screen_questions") ||
                changedKeys.includes("interview_type")) &&
              index === 2
            ) {
              return {
                ...item,
                status: "Review Pending",
                disabled: false,
                loading: false,
              };
            } else if (
              (changedKeys.includes("job_title") ||
                changedKeys.includes("company_name") ||
                changedKeys.includes("industry") ||
                changedKeys.includes("pay_rate") ||
                changedKeys.includes("management_level") ||
                changedKeys.includes("employment") ||
                changedKeys.includes("start_date") ||
                changedKeys.includes("end_date") ||
                changedKeys.includes("occupational_classification") ||
                changedKeys.includes("reports_to") ||
                changedKeys.includes("req_id") ||
                changedKeys.includes("bu_department_team") ||
                changedKeys.includes("company_profile") ||
                changedKeys.includes("education") ||
                changedKeys.includes("specific_degree") ||
                changedKeys.includes("dei") ||
                changedKeys.includes("govt_security_clearance") ||
                changedKeys.includes("languages") ||
                changedKeys.includes("certificates") ||
                changedKeys.includes("employer_targets") ||
                changedKeys.includes("location") ||
                changedKeys.includes("work_location_type") ||
                changedKeys.includes("location_targets") ||
                changedKeys.includes("shift") ||
                changedKeys.includes("visa_status") ||
                changedKeys.includes("required_years_for_industry")) &&
              index === 0
            ) {
              return {
                ...item,
                status: "Review Pending",
                disabled: false,
                loading: false,
              };
            }
            return item;
          })
        );

        dispatch(JobJobFormikData(clonedJobValue, getValues));
      }
    }, 10);

    return () => {
      clearTimeout(handler);
    };
  }, [jobValue]);

  const CustomMenuItem = (item, index) => {
    return (
      <MenuItem value={item} key={index}>
        {item?.name}
      </MenuItem>
    );
  };

  const handleSkillWarningClose = () => {
    setSkillDialog((prev) => ({
      ...prev,
      warning: false,
      disabled: false,
      stayLoading: false,
      leaveLoading: false,
    }));
  };

  const handleWarning = (condition) => {
    if (condition === "stay") {
      setSkillDialog((prev) => ({
        ...prev,
        stayLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleSkillWarningClose();
      }, 1000);
    } else {
      setSkillDialog((prev) => ({
        ...prev,
        leaveLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        setSkillDialog({
          open: false,
          condition: false,
          stayLoading: false,
          leaveLoading: false,
          warning: false,
          disabled: false,
        });
      }, 1000);
    }
  };

  const SkillWarning = () => {
    return (
      <CommonGrid2 display={"flex"} gap={"1rem"}>
        <CommonButton
          value={"Stay"}
          variant="outlined"
          color="#344054"
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          border={"#D0D5DD"}
          onClick={() => handleWarning("stay")}
          disabled={skillDialog.disabled}
          loading={skillDialog.stayLoading}
        />
        <CommonButton
          value={"Leave"}
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={skillDialog.disabled}
          loading={skillDialog.leaveLoading}
          onClick={() => handleWarning("leave")}
        />
      </CommonGrid2>
    );
  };

  const handleRescoreCheckboxClick = (check) => {
    setCheckBox((prev) => {
      const updatedCheckBox = prev.map((item) => {
        if (item.title === check.title && item.title === "Job Description") {
          const newValue = !item.value;
          return { ...item, value: newValue };
        }

        if (
          item.title === check.title &&
          item.child &&
          item.title === "Candidates"
        ) {
          const newValue = !item.value;
          return {
            ...item,
            value: newValue,
            child: item.child.map((child) => ({ ...child, value: newValue })),
          };
        }

        if (check.title === "Job Description") {
          const jobDescriptionValue = prev.find(
            (i) => i.title === "Job Description"
          )?.value;
          if (
            item.title === "Golden Record" ||
            item.title === "Hiring Manager"
          ) {
            return {
              ...item,
              value: !jobDescriptionValue,
              child: item.child?.map((child) => ({
                ...child,
                value: !jobDescriptionValue,
              })),
            };
          }
        }

        if (item.child) {
          const newChild = item.child.map((child) => {
            if (child.id === check.id) {
              return { ...child, value: !child.value };
            }
            return child;
          });
          const allChildrenChecked = newChild.every(
            (child) => child.value === true
          );

          return {
            ...item,
            value: allChildrenChecked,
            child: newChild,
          };
        }

        return item;
      });

      const fileData = updatedCheckBox.flatMap((item) => {
        if (item.title === "Job Description" && item.value) {
          return [
            {
              ...item,
              type: "JobDescription.docx",
              progress: 0,
              buffer: 0,
              visible: false,
            },
          ];
        }

        if (item.child && Array.isArray(item.child)) {
          return item.child
            .filter((child) => child.value)
            .map((child) => ({
              ...child,
              progress: 0,
              buffer: 0,
              type: child.file_name,
              visible: false,
            }));
        }

        return [];
      });
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};

      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: fileData,
            status: "",
          },
        })
      );
      dispatch(JobJobRescore({ id: jobId, data: fileData, status: "fail" }));

      return updatedCheckBox;
    });
  };

  const handleRescoreCheckboxOnlyClick = (check) => {
    setCheckBox((prev) => {
      return prev.map((item) => {
        if (
          item.title !== "Hiring Manager" &&
          item.title !== "Golden Record" &&
          item.child
        ) {
          const newChild = item.child.map((child) => {
            if (child.id === check.id) {
              return { ...child, value: child.id === check.id };
            }
            return { ...child, value: false };
          });

          return {
            ...item,
            value: false,
            child: newChild,
          };
        }

        return item;
      });
    });
  };

  const rescoreContent = () => {
    return (
      <CommonGrid2>
        <Typography
          variant="h3"
          textAlign={"left"}
          color="#101828"
          fontSize={"18px"}
        >
          Rescore Records
        </Typography>
        <Typography
          variant="h5"
          textAlign={"left"}
          color="#8396A8"
          marginTop={"10px"}
          fontSize={"15px"}
        >
          {jobData.data?.job_details?.job_title}
          {jobData.data?.job_details?.company_name &&
            " - " + jobData.data?.job_details?.company_name}
        </Typography>

        <CommonGrid2
          display={"flex"}
          alignItems={"start"}
          gap={"10px"}
          marginTop={"10px"}
          background="#F7F8F9"
          padding={"5px"}
          borderRadius={"10px"}
        >
          <CustomDiv>
            <ExclamatoryIco />
          </CustomDiv>

          <CommonGrid2
            display={"flex"}
            alignItems={"start"}
            flexDirection={"column"}
            gap={"5px"}
          >
            <Typography variant="semibold" fontWeight={600}>
              Please Note !
            </Typography>
            <Typography
              variant="subtitle2"
              fontWeight={600}
              textAlign={"start"}
            >
              This record will be rescored based on the updated inputs. As a
              result, some fields in the current record may be updated.
            </Typography>
          </CommonGrid2>
        </CommonGrid2>

        {!reScore.file ? (
          <CommonGrid2 margin={"1rem 0px 0px"}>
            {checkBox.map((item) => (
              <Fragment>
                <CommonGrid2
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  onClick={() =>
                    item.title === "Hiring Manager" ||
                    item.title === "Golden Record"
                      ? {}
                      : handleRescoreCheckboxClick(item)
                  }
                  cursor={
                    item.title === "Hiring Manager" ||
                    item.title === "Golden Record"
                      ? "auto"
                      : "pointer"
                  }
                >
                  <Typography
                    color="#101828"
                    fontSize={"14px"}
                    fontWeight={600}
                  >
                    {item.title}
                  </Typography>
                  <CommonGrid2 display={"flex"} alignItems={"center"}>
                    {item.title === "Candidates" && (
                      <Typography color="#101828" fontSize={"14px"}>
                        All
                      </Typography>
                    )}
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": { width: 20, height: 20 },
                        cursor:
                          item.title === "Hiring Manager" ||
                          item.title === "Golden Record"
                            ? "auto"
                            : "pointer",
                      }}
                      onClick={(e) => {
                        if (
                          item.title === "Hiring Manager" ||
                          item.title === "Golden Record"
                        )
                          return;
                        e.stopPropagation();
                        handleRescoreCheckboxClick(item);
                      }}
                      checked={item.value}
                      indeterminate={
                        item.child &&
                        item.child.every((child) => child.value === true)
                          ? false
                          : item.child &&
                            item.child.some((child) => child.value === true)
                      }
                    />
                  </CommonGrid2>
                </CommonGrid2>
                {item.child && (
                  <CommonGrid2 marginLeft={"2rem"}>
                    {item.child.map((child, index) => (
                      <CommonGrid2
                        key={child.id}
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        cursor={
                          child.record_type === "HIRING MANAGER" ||
                          child.record_type === "GOLDEN RECORD"
                            ? "auto"
                            : "pointer"
                        }
                        onMouseEnter={() => {
                          if (
                            child.record_type === "HIRING MANAGER" ||
                            child.record_type === "GOLDEN RECORD"
                          )
                            return;
                          setHoveredId(child.id);
                        }}
                        onMouseLeave={() => {
                          if (
                            child.record_type === "HIRING MANAGER" ||
                            child.record_type === "GOLDEN RECORD"
                          )
                            return;
                          setHoveredId(null);
                        }}
                        onClick={() => {
                          if (
                            child.record_type === "HIRING MANAGER" ||
                            child.record_type === "GOLDEN RECORD"
                          )
                            return;
                          handleRescoreCheckboxClick(child);
                        }}
                      >
                        <Typography
                          color="#101828"
                          fontSize={"14px"}
                          fontWeight={500}
                        >
                          {child.title}
                        </Typography>
                        <CommonGrid2
                          display={"flex"}
                          gap={"10px"}
                          alignItems={"center"}
                        >
                          {hoveredId === child.id && (
                            <CommonButton
                              value={"Only"}
                              padding={"1px 10px"}
                              height={"max-content"}
                              borderRadius={"5px"}
                              onClick={(e) => {
                                if (
                                  child.record_type === "HIRING MANAGER" ||
                                  child.record_type === "GOLDEN RECORD"
                                )
                                  return;
                                e.stopPropagation();
                                handleRescoreCheckboxOnlyClick(child);
                              }}
                            />
                          )}
                          {child.record_type !== "HIRING MANAGER" &&
                            child.record_type !== "GOLDEN RECORD" && (
                              <Checkbox
                                checked={child.value}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    width: 20,
                                    height: 20,
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRescoreCheckboxClick(child);
                                }}
                              />
                            )}
                        </CommonGrid2>
                      </CommonGrid2>
                    ))}
                  </CommonGrid2>
                )}
              </Fragment>
            ))}
          </CommonGrid2>
        ) : (
          WholeProgressView()
        )}
      </CommonGrid2>
    );
  };

  const rescoreConfirmation = () => {
    return (
      <CommonGrid2>
        <Typography variant="h3" color="#101828" fontSize={"18px"}>
          Do you want to Rescore ?
        </Typography>
        <Typography
          variant="h5"
          color="#8396A8"
          marginTop={"10px"}
          fontSize={"15px"}
        >
          A new note has been added, a rescore might be necessary
        </Typography>
      </CommonGrid2>
    );
  };

  const handleSearchStringClose = () => {
    setGenerateSearch({
      open: false,
      copied: false,
    });
  };

  const handleSearchStringClick = () => {
    setGenerateSearch({
      open: true,
    });
  };

  const handleCardChange = (event, newValue) => {
    setCardValue({ value: newValue, prev: cardValue.value });
  };

  const handleMarkAsVerified = async (
    index,
    values,
    validateForm,
    setTouched
  ) => {
    const errors = await validateForm();

    const requiredFields =
      index === 1
        ? basicInformationRequiredFields
        : index === 2
        ? ["skillData"]
        : index === 3
        ? ["pre_screen_questions", "enable_dynamic_pre_screen_questions"]
        : [];

    const hasError = requiredFields.some((field) => Boolean(errors[field]));

    if (hasError) {
      const errorElement = document.querySelector(".Mui-error");
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    } else {
      setJobValidationCheck(jobValue);
      setCardData((prev) =>
        prev.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              disabled: true,
              loading: true,
            };
          }
          return item;
        })
      );
      setTimeout(() => {
        setCardData((prev) =>
          prev.map((item, i) => {
            if (i === index) {
              return {
                ...item,
                status: "Verified",
                disabled: true,
                loading: false,
              };
            }
            return item;
          })
        );
      }, 1000);
    }
  };

  const handleResumeUploadDialogClose = () => {
    setResumeUploadDialogOpen((prev) => ({
      ...prev,
      open: false,
      loading: false,
      data_filled: false,
    }));
  };

  const handleShareResumeUpload = async (values) => {
    setResumeUploadDialogOpen((prev) => ({ ...prev, loading: true }));
    try {
      let payload = {
        job_id: jobId,
        url: values.url,
        max_resumes: parseInt(values.max_resumes),
        to_emails: values.shareData,
        job_name: query.get("title"),
      };
      const data = await ResumePortalShare(payload);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      setResumeUploadDialogOpen((prev) => ({
        ...prev,
        loading: false,
        data_filled: true,
      }));
      fetchJobDataDetail(jobId);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setResumeUploadDialogOpen((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleMenuItem = (e, name) => {
    const value = e.target.value;
    setJobValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGoToJob = (row, condition) => {
    const URL = process.env.REACT_APP_URL;
    if (condition) {
      window.open(
        `${URL}/jobs/jobs-view?id=${row.id}&title=${row.job_title}&value=1&chatBot=true`,
        "_blank",
        "noopener,noreferrer"
      );
    } else
      window.open(
        `${URL}/jobs/jobs-view?id=${row.id}&title=${row.job_title}&value=1`,
        "_blank",
        "noopener,noreferrer"
      );
  };

  const handleReviewInfoClose = async () => {
    setReviewInfo((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      rescoreLoading: false,
      draftLoading: false,
    }));

    if (alignment === "View") {
      await fetchJobDataDetail(jobId);
      await fetchJobEdit(jobId);
    }
  };
  const handleReviewInfo = () => {
    setReviewInfo((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleIgnoreToggle = (index) => {
    setJobValue((prev) => ({
      ...prev,
      insights: {
        ...prev.insights,
        insights: prev.insights.insights.map((item, i) =>
          i === index ? { ...item, is_ignored: !item.is_ignored } : item
        ),
      },
    }));
  };

  const handleFieldLevelIgnoreToggle = (item) => {
    setJobValue((prev) => ({
      ...prev,
      [item.anomalyFieldName]: {
        ...prev[item.anomalyFieldName],
        is_ignored: !prev[item.anomalyFieldName]?.is_ignored,
      },
    }));
  };

  const validInsights = jobValue?.insights?.insights?.filter((item) => {
    return (
      Array.isArray(item?.fields) && item?.fields?.some(Boolean) // at least one valid field
    );
  });

  const inferredFields = jobValue?.insights?.inferered_fields || [];

  const filterInferredSkill = inferredSkill?.filter((item) =>
    inferredFields?.includes(item?.titleName)
  );

  const filterFieldLevelData = fieldLevelData
    .filter((item) => item.anomaly_detected?.anomaly_detected === "yes")
    .filter(
      (item, index, self) =>
        index === self.findIndex((i) => i.titleName === item.titleName)
    );

  const handleAnomalyCheck = (e) => {
    setJobValue((prev) => ({
      ...prev,
      is_inference_reviewed: e.target.checked,
    }));
  };

  React.useEffect(() => {
    if (reviewInfo.open) {
      const filtered = mandatoryData.filter(
        (item) => jobValue?.[item?.titleName] === ""
      );
      setFilterMandatoryData((prev) => ({
        ...prev,
        mandatoryDisabled:
          alignment === "View"
            ? !(
                jobData.data?.job_details?.job_title &&
                jobData.data?.job_details?.company_name
              )
            : !(jobValue?.job_title && jobValue?.company_name),
        mandatoryData: filtered,
      }));
    }
  }, [reviewInfo.open]);

  // const handleDataTime = (newValue) => {
  //   if (!newValue) {
  //     setJobValue((prev) => ({ ...prev, submission_deadline: null }));
  //     return;
  //   }

  //   setJobValue((prev) => ({
  //     // ← ADD
  //     ...prev,
  //     submission_deadline: newValue.toISOString(),
  //   }));
  // };

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={jobValue}
        validationSchema={validationSchema}
        // validateOnChange={false}
        // validateOnBlur={false}
        // validateOnMount={false}
        // validate={() => {}}
        onSubmit={async (values, actions) => {
          handleSubmitJob(values, actions);
        }}
      >
        {({ values, errors, validateForm, setTouched, setFieldValue }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
              ref={ref}
            >
              <Grid2 container spacing={2}>
                <CommonGrid2
                  size={{ xs: 12, md: 5, sm: 12 }}
                  item
                  alignItems={"start"}
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                >
                  {isLoading.isLoading ? (
                    <HandleSkeletion height={90} width={"60%"} />
                  ) : (
                    <CustomDiv>
                      <Typography variant="h3" lineHeight={"normal"}>
                        {jobData.data?.job_details?.job_title}
                      </Typography>
                      <Typography variant="h6">
                        {jobData.data?.job_details?.company_name}
                        {jobData.data?.job_details?.req_id &&
                          " - " + jobData.data?.job_details?.req_id}
                      </Typography>
                      <Typography variant="p">
                        <b>Job ID :</b>{" "}
                        {jobData.data?.job_details?.job_order_no}
                      </Typography>
                    </CustomDiv>
                  )}
                </CommonGrid2>
                <CommonGrid2
                  item
                  size={{ xs: 12, md: 7, sm: 12 }}
                  gap="10px"
                  display="flex"
                  justifyContent={"end"}
                  alignItems={"end"}
                  flexDirection={"column"}
                  height={"fit-content"}
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"row"}
                    size="12"
                    gap={"1rem"}
                    flexWrap={"wrap"}
                    width={"100%"}
                    justifyContent="end"
                  >
                    {jobData.data?.job_details?.is_scored && (
                      <CommonButton
                        variant="outlined"
                        color="#344054"
                        border="#D0D5DD"
                        fontWeight="600"
                        value="Generate Search Strings"
                        padding={"10px 20px"}
                        onClick={handleSearchStringClick}
                        disabled={
                          isLoading.isLoading ||
                          jobStatus === "Closed" ||
                          jobStatus === "Cancelled" ||
                          jobStatus === "Filled"
                        }
                      />
                    )}

                    {alignment === "Edit" && (
                      <CommonButton
                        value="Submit"
                        padding="5px 2rem"
                        fontWeight="600"
                        type="submit"
                        disabled={
                          editButtonLoading ||
                          isLoading.isLoading ||
                          JSON.stringify(JobEditData.formikData) ===
                            JSON.stringify(JobEditData.jobData)
                        }
                        loading={editButtonLoading}
                        onClick={async () => {
                          let data = await validateForm();
                          // setTimeout(() => {
                          handleScrollToError(data);
                          // }, 0);
                        }}
                      />
                    )}

                    <ToogleButton
                      ToogleData={ToogleData}
                      handleChange={handleToogleChange}
                      alignment={alignment}
                      border={"1px solid #D0D5DD"}
                      borderRadius={"8px"}
                      activeColor={"#344054"}
                      color={"#344054"}
                      activeBackgroundColor="#F9FAFB"
                      backgroundColor="#FFFF"
                      disabled={
                        isLoading.isLoading ||
                        jobStatus === "Closed" ||
                        jobStatus === "Cancelled" ||
                        jobStatus === "Filled"
                      }
                    />
                    <div>
                      <CommonButton
                        value={<DotsVerticalIco />}
                        padding={"13px 14px"}
                        variant="outlined"
                        color={"#344054"}
                        border={"#D0D5DD"}
                        fontWeight={"600"}
                        svg={true}
                        aria-controls={menuOpen ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={menuOpen ? "true" : undefined}
                        onClick={handleMenuClick}
                        minWidth={"20px !important"}
                      />

                      <CustomizeMenu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={menuOpen}
                        onClose={handleMenuClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        {menuItems.map((item, index) => (
                          <MenuItem
                            key={index}
                            onClick={item.disabled ? () => {} : item.onClick}
                            aria-controls={item.ariaControls}
                            aria-haspopup={item.ariaHasPopup}
                            aria-expanded={item.ariaExpanded}
                            style={{ opacity: item.disabled ? 0.5 : 1 }}
                            disabled={item?.disabled}
                          >
                            <StyledFlexRowView>
                              {item.icon}
                              <Typography>{item.label}</Typography>
                            </StyledFlexRowView>
                          </MenuItem>
                        ))}
                      </CustomizeMenu>
                    </div>
                    {(alignment === "View"
                      ? jobData.data?.show_rescore
                      : alignment !== "Edit") && (
                      <CommonButton
                        fontWeight="600"
                        startIcon={
                          !backGroundprocess.openLoading && <RefreshIcon />
                        }
                        value="Rerun Scoring"
                        padding="10px 20px"
                        gap={!backGroundprocess.openLoading && "0px"}
                        disabled={
                          isLoading.isLoading ||
                          backGroundprocess.openLoading ||
                          jobStatus === "Closed" ||
                          jobStatus === "Cancelled" ||
                          jobStatus === "Filled"
                        }
                        loading={backGroundprocess.openLoading}
                        onClick={() => handleClickRerun()}
                      />
                    )}
                  </CommonGrid2>
                  {isLoading.isLoading ? (
                    <HandleSkeletion height={50} width={"60%"} />
                  ) : (
                    <CommonGrid2
                      display={"flex"}
                      gap={"1rem"}
                      alignItems={"end"}
                      flexWrap={"wrap"}
                    >
                      <CommonGrid2
                        display={"flex"}
                        gap={"5px"}
                        alignItems={"center"}
                      >
                        <Typography
                          variant="body4"
                          fontWeight={alignment === "View" && 600}
                        >
                          {alignment === "View"
                            ? "Priority : "
                            : " Set as High Priority"}{" "}
                        </Typography>

                        {alignment === "View" ? (
                          <Typography
                            variant="body4"
                            fontWeight={700}
                            color={
                              values.priority_type === "normal"
                                ? "#079455"
                                : "#FF5C77"
                            }
                          >
                            {values.priority_type === "normal"
                              ? "Normal"
                              : "High"}
                          </Typography>
                        ) : (
                          <CustomTooltip
                            title={
                              values.priority_type === "normal"
                                ? "Normal"
                                : "High"
                            }
                            fontWeight={600}
                          >
                            <CustomDiv>
                              <Switch
                                checked={
                                  values.priority_type === "high_priority"
                                }
                                onChange={(event) =>
                                  setJobValue((prev) => ({
                                    ...prev,
                                    priority_type: event.target.checked
                                      ? "high_priority"
                                      : "normal",
                                  }))
                                }
                              />
                            </CustomDiv>
                          </CustomTooltip>
                        )}
                      </CommonGrid2>
                      {/* <CommonGrid2
                        display={"flex"}
                        gap={"5px"}
                        alignItems={"center"}
                      >
                        <Typography variant="body4">Vision Assist</Typography>
                        <Switch
                          checked={iconVisible}
                          onChange={(event) =>
                            setIconVisible(event.target.checked)
                          }
                        />
                      </CommonGrid2> */}
                    </CommonGrid2>
                  )}
                </CommonGrid2>
                <JobMetaInfo
                  mode={alignment === "View" ? "view" : "edit"}
                  isLoading={isLoading.isLoading}
                  jobData={jobData}
                  dateTime={jobData?.data?.job_details?.submission_deadline}
                  values={values}
                  errors={errors}
                  userData={userData}
                  handleMenuItem={handleMenuItem}
                  handleDataTime={(newValue) =>
                    CreatehandleDataTime(newValue, setJobValue)
                  }
                />
              </Grid2>
              {(alignment === "View" ||
                (alignment === "Edit" && JobJobEditData.is_scored)) && (
                <Score
                  jobData={
                    alignment === "View"
                      ? jobData.data?.job_details
                      : JobJobEditData
                  }
                  // data={jobData.search_strategy}
                  isLoading={fixLoader ? false : isLoading.isLoading}
                  fixLoader={fixLoader}
                  fetchJobsList={fetchJobsList}
                  job_id={jobId}
                  searchLoading={isLoading.searchLoading}
                  toolTipOpen={
                    fixLoader ? false : alignment === "View" ? true : false
                  }
                  handleReviewInfo={handleReviewInfo}
                  mandatoryDisabled={
                    alignment === "View"
                      ? !(
                          jobData.data?.job_details?.job_title &&
                          jobData.data?.job_details?.company_name
                        )
                      : !(jobValue?.job_title && jobValue?.company_name)
                  }
                  anomalyDisabled={
                    jobData.data?.job_details?.insights?.insights?.length !==
                      0 && validInsights?.length !== 0
                  }
                  filterInferredSkill={filterInferredSkill?.length !== 0}
                  filterFieldLevelData={filterFieldLevelData?.length !== 0}
                  hideCondition={false}
                />
              )}
              {(alignment === "View"
                ? jobData.data?.job_details?.relevancy_index !== null
                : values["relevancy_index"] !== null) && (
                <Grid2 marginTop={"3rem"}>
                  <CommonAccordion
                    title={"Relevancy Index"}
                    icon={<RelevancyIndexIco />}
                    customStyle={{ marginTop: "2rem" }}
                    children={
                      <RelevancyTable
                        alignment={alignment}
                        isLoading={isLoading.isLoading}
                        resultHeaderData={resultHeaderData}
                        onDragEnd={onRelevancyDragEnd}
                        jobData={jobData.data}
                        // dragContent={
                        //   alignment === "View"
                        //     ? jobData.data?.job_details?.relevancy_index
                        //     : values["relevancy_index"]
                        // }
                        iconVisible={iconVisible}
                        getToolTipIcon={getToolTipIcon}
                      />
                    }
                  />
                  {/* <RelevancyTable
                    alignment={alignment}
                    isLoading={isLoading.isLoading}
                    resultHeaderData={resultHeaderData}
                    onDragEnd={onRelevancyDragEnd}
                    jobData={jobData.data}
                    // dragContent={
                    //   alignment === "View"
                    //     ? jobData.data?.job_details?.relevancy_index
                    //     : values["relevancy_index"]
                    // }
                    iconVisible={iconVisible}
                    getToolTipIcon={getToolTipIcon}
                  /> */}
                </Grid2>
              )}

              <CommonAccordion
                title={"Closed Jobs similar to this"}
                icon={<ClosedJobIco />}
                customStyle={{ marginTop: "2rem" }}
                children={
                  <JobReDiscovery
                    loading={isLoading.isLoading}
                    checkWidth={bounds.width}
                    data={jobData.data?.jobs_rediscovered || []}
                    handleGoToJob={handleGoToJob}
                  />
                }
              />

              <Typography variant="h3" margin={"2rem 0px"} fontWeight={600}>
                {"Check List"}
              </Typography>

              <TabContext value={cardValue.value}>
                <CommonGrid2
                  container
                  spacing={2}
                  alignItems="center"
                  marginTop={2.5}
                >
                  <TabCardSection
                    onChange={handleCardChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="visible arrows tabs example"
                    breakpoint={bounds.width < 890 ? "2000" : "1400"}
                  >
                    {cardData.map((item, index) => (
                      <Tab
                        value={index}
                        label={
                          <Grid2
                            item
                            key={index}
                            size={12}
                            display={"flex"}
                            flexDirection={"column"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            height={"100%"}
                            gap={"1rem"}
                          >
                            {isLoading.isLoading ? (
                              <HandleSkeletion
                                width="50px"
                                height="50px"
                                marginRight={"1rem"}
                                transform="scale(1)"
                                borderRadius="50px"
                              />
                            ) : (
                              item?.icon
                            )}
                            {isLoading.isLoading ? (
                              <HandleSkeletion
                                width="100%"
                                height="30px"
                                transform="scale(1)"
                              />
                            ) : (
                              <CommonGrid2>
                                <Typography
                                  fontSize={"15px"}
                                  fontWeight={600}
                                  color={"#101828"}
                                >
                                  {item.name}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  display={"flex"}
                                  alignItems={"center"}
                                  justifyContent={"center"}
                                  fontSize={"12px"}
                                  fontWeight={500}
                                  color={"#475467"}
                                  marginTop={"8px"}
                                >
                                  {item.status === "Review Pending" ? (
                                    <ReviewPendingIco size={22} />
                                  ) : (
                                    <VerifiedIco />
                                  )}
                                  &nbsp;&nbsp;&nbsp;
                                  {item.status}
                                </Typography>
                              </CommonGrid2>
                            )}
                          </Grid2>
                        }
                      />
                    ))}
                  </TabCardSection>
                </CommonGrid2>

                <CommonGrid2 style={{ overflow: "hidden" }}>
                  {accordionDataView.map((item, index) => (
                    <Slide
                      direction={
                        cardValue.value > cardValue.prev ? "right" : "left"
                      }
                      in={cardValue.value === index}
                      timeout={500}
                      mountOnEnter
                      unmountOnExit
                    >
                      <TabPanelView value={index} padding="0rem 0px 0px">
                        <CommonGrid2 size={12} padding={"1rem 0rem"}>
                          {(item.title || alignment === "Edit") && (
                            <CommonGrid2
                              display={"flex"}
                              justifyContent={"space-between"}
                              alignItems={"center"}
                              padding={"1rem 0rem"}
                            >
                              <Typography
                                variant="h4"
                                margin={"15px 0px"}
                                fontWeight={600}
                              >
                                {item.title}
                              </Typography>
                              <CommonGrid2
                                display={"flex"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                                padding={"1rem 0rem"}
                                gap={"1rem"}
                              >
                                {alignment === "Edit" && (
                                  <CustomDiv position="relative">
                                    <CommonButton
                                      variant="contained"
                                      color="white"
                                      background="#7F56D9"
                                      fontWeight="600"
                                      padding={"10px 20px"}
                                      value={"Mark as verified"}
                                      disabled={
                                        cardData[index].disabled ||
                                        isLoading.isLoading
                                      }
                                      loading={cardData[index].loading}
                                      onClick={() =>
                                        handleMarkAsVerified(
                                          index,
                                          values,
                                          validateForm,
                                          setTouched
                                        )
                                      }
                                    />
                                    {errors.marked_as_verified &&
                                      !cardData[index].disabled && (
                                        <CustomTooltipField
                                          size={7}
                                          top="-40px"
                                          className="Mui-error"
                                        >
                                          Kindly verify this section
                                        </CustomTooltipField>
                                      )}
                                  </CustomDiv>
                                )}
                              </CommonGrid2>
                            </CommonGrid2>
                          )}

                          {item.component}
                        </CommonGrid2>
                      </TabPanelView>
                    </Slide>
                  ))}
                </CommonGrid2>
              </TabContext>

              <AddNewSkillDialog
                open={skillDialog.open}
                skillDialog={skillDialog}
                handleClose={handleClose}
                jobModifyData={jobModifyData}
                handleSkillClick={handleSkillClick}
                buttonLoading={buttonLoading}
              />
              <SkillDeleteDialog
                deleteDialog={deleteDialog}
                handleDeleteDialogClose={handleDeleteDialogClose}
                handleDeleteSkill={handleDeleteSkill}
                buttonLoading={buttonLoading}
                title="Delete Skill"
                content={dialogData?.data?.skill}
              />

              <SkillDeleteDialog
                deleteDialog={seededDialog.deleteOpen}
                handleDeleteDialogClose={handleSeededClose}
                handleDeleteSkill={handleDeleteSeeded}
                buttonLoading={seededDialog.loading}
                title="Delete Seeded Pre-Screen"
                content={seededDialog.content}
              />
              <AddSeededDialog
                open={seededDialog.addOpen}
                handleDialogClose={handleSeededClose}
                handleSubmit={handleAddSubmit}
                loading={seededDialog.loading}
              />

              {reviewInfo.open && (
                <ReviewInfo
                  values={values}
                  reviewInfo={reviewInfo}
                  handleClose={handleReviewInfoClose}
                  jobValue={jobValue}
                  mandatoryData={mandatoryData}
                  anomalyData={anomalyData}
                  handleKeepAsDraft={handleKeepAsDraft}
                  handleIgnoreToggle={handleIgnoreToggle}
                  validInsights={validInsights}
                  mandatoryDisabled={
                    alignment === "View"
                      ? !(
                          jobData.data?.job_details?.job_title &&
                          jobData.data?.job_details?.company_name
                        )
                      : !(jobValue?.job_title && jobValue?.company_name)
                  }
                  handleAnomalyCheck={handleAnomalyCheck}
                  menuItemData={menuItemData}
                  disabledButton={
                    JSON.stringify(JobEditData.formikData) ===
                    JSON.stringify(JobEditData.jobData)
                  }
                  fieldLevelData={fieldLevelData}
                  filterInferredSkill={filterInferredSkill}
                  filterFieldLevelData={filterFieldLevelData}
                  filterMandatoryData={filterMandatoryData}
                  handleFieldLevelIgnoreToggle={handleFieldLevelIgnoreToggle}
                />
              )}
            </Form>
          );
        }}
      </Formik>

      <AttachmentDialog
        open={attachmentDialog.open}
        handleClose={handleAttachmentClose}
        handleSubmit={handleAttachmentSubmit}
        attachmentDialog={attachmentDialog}
        condition={"Job"}
      />

      <SkillDeleteDialog
        deleteDialog={deleteButton.open}
        handleDeleteDialogClose={handelAttachmentDialogClose}
        handleDeleteSkill={handleDeleteAttachment}
        buttonLoading={deleteButton.loading}
        title="Delete Attachment"
        content={deleteButton.content}
      />

      <NewDeleteNote
        deleteNoteDialogOpen={deleteNoteDialogOpen}
        handleDeleteNoteDialogClose={handleDeleteNoteDialogClose}
        noteList={noteList}
        handleDeleteNoteById={handleDeleteNoteById}
        noteLoading={noteList.loading}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      {/* <DialogCandidateHub
        open={reScore.rescore}
        // disabled={reScore.disabled}
        closeIcon={true}
        handleButttonClose={handleRescoreClose}
        footer={<Footer />}
        icon={""}
        titlepadding={"0px 0px 16px"}
        title="Re-Score"
        content={
          <>
            {reScore.noteOpen ? "Do you want to rescore?" : ""}
            {reScore?.file && WholeProgressView()}
          </>
        }
      /> */}

      <DialogCandidateHub
        open={reScore.rescore}
        closeIcon={true}
        handleButttonClose={handleRescoreClose}
        footer={reScore.noteOpen ? <ConfirmationButton /> : <Footer />}
        icon={<RescoreIco />}
        titlepadding={"0px 0px 16px"}
        customStyle={{ top: "-6px" }}
        content={reScore.noteOpen ? rescoreConfirmation() : rescoreContent()}
      />

      <CreateNote
        openNoteDialog={noteList.open}
        handleCloseNoteDialog={handleCloseNoteDialog}
        id={noteList.noteId}
        //
        noteUpperData={noteUpperData}
        typeData={typeData}
        noteList={noteList}
        handleNoteSubmit={handleCreateNote}
        loading={noteList.loading}
      />
      <ShareQuickMatch
        title="Share Job Description"
        shareDialogOpen={shareDialogOpen.open}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
        isLoading={shareDialogOpen.loading}
        condition={true}
        statusOptions={statusOptions}
        CustomMenuItem={CustomMenuItem}
        jobData={jobData.data}
      />
      <DialogCandidateHub
        open={backGroundprocess.open}
        // icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Processing"
        titlepadding={"0px 0px 16px"}
        handleClose={handlebackGroundWarningClose}
        footer={<BackGroundFooter />}
        content={
          "A background process is in progress. Please wait a few minutes while it completes."
        }
      />
      <DialogCandidateHub
        open={skillDialog.warning}
        title="Warning"
        titlepadding={"0px 0px 16px"}
        handleClose={handleSkillWarningClose}
        footer={<SkillWarning />}
        content={"Changes will be lost. Do you want to leave?"}
      />

      {generateSearch.open && (
        <GenerateSearchStringContent
          jobId={jobId}
          jobData={jobData}
          generateSearch={generateSearch}
          handleCopyClick={(text) =>
            handleCopyClick({ text, state: setGenerateSearch })
          }
          handleCopyMouseLeave={() =>
            handleCopyMouseLeave({ state: setGenerateSearch })
          }
          handleDialogClose={handleSearchStringClose}
        />
      )}

      <ResumeUploadPortalLink
        shareDialogOpen={resumeUploadDialogOpen}
        handleShareDialogClose={handleResumeUploadDialogClose}
        handleShareResumeUpload={handleShareResumeUpload}
        isLoading={resumeUploadDialogOpen.loading}
      />
    </div>
  );
};
export default JobInformation;
